var _g, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _ellipse, _ellipse2, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOwner(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 256 337",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    strokeWidth: 2,
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "#b59a97",
    vectorEffect: "non-scaling-stroke",
    d: "m142.06 13.51.3 5.97"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#818181",
    vectorEffect: "non-scaling-stroke",
    d: "M142.36 19.48q-1.68 4.63 1.76 8.05"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#ffcdbe",
    vectorEffect: "non-scaling-stroke",
    d: "m144.12 27.53 2.33 10.01"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#818181",
    vectorEffect: "non-scaling-stroke",
    d: "M146.45 37.54q-2.45 2.42 4.11 1.92a.7.57 31.8 0 1 .42 1.21q-.88.16-1.58-.23-.46-.26-.63.24-.16.5.26 1.07"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#ffcdbe",
    vectorEffect: "non-scaling-stroke",
    d: "M149.03 41.75q.81 7.42 5.3 14.41"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#9d8c8b",
    vectorEffect: "non-scaling-stroke",
    d: "M154.33 56.16q-.18.26-.35.52"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#969da2",
    vectorEffect: "non-scaling-stroke",
    d: "M153.98 56.68q-9.99 1.24-19.78.75c-4.84-.24-8.07 4.85-11.04 7.7-1.74 1.67-4.34 2.78-6.25 4.81"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#909396",
    vectorEffect: "non-scaling-stroke",
    d: "M116.91 69.94q-2.97 3.77-7.56 6.49"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#ebecec",
    vectorEffect: "non-scaling-stroke",
    d: "m109.35 76.43-49.69-.99a1.92 1.91-6.4 0 0-1.9 2.37l7.25 29.4"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#ebc2aa",
    vectorEffect: "non-scaling-stroke",
    d: "M65.01 107.21c-21.56.36-43.61 2.07-64.01 9.18"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#ceae9c",
    vectorEffect: "non-scaling-stroke",
    d: "M1 116.39q-1.74 2.82.6 5.25.34.35.83.39l5.82.44"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#b39c90",
    vectorEffect: "non-scaling-stroke",
    d: "m8.25 122.47 13.38 63.68"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#9eacb1",
    vectorEffect: "non-scaling-stroke",
    d: "M21.63 186.15c-.6 4.4-3 20.01.97 23.35"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#909396",
    vectorEffect: "non-scaling-stroke",
    d: "m22.6 209.5-3.1 2.69"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#b39c90",
    vectorEffect: "non-scaling-stroke",
    d: "M19.5 212.19q-3.25 3.38-2.35 8.97.09.54.63.61l11.25 1.57q.43.05.37.48l-1.45 10.91"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#ceae9c",
    vectorEffect: "non-scaling-stroke",
    d: "m27.95 234.73-4.67 41.08a2.24 2.23-80.7 0 0 1.74 2.43q3.02.68 5.91-.45.52-.2.67-.73l6.93-23.55"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#b39c90",
    vectorEffect: "non-scaling-stroke",
    d: "m38.53 253.51 4.95-17.29"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#998d88",
    vectorEffect: "non-scaling-stroke",
    d: "m43.48 236.22 9.56-1.2"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#909396",
    vectorEffect: "non-scaling-stroke",
    d: "M53.04 235.02q-2.29 15.19-4.63 30.22c-.81 5.22 4 8.06 8.17 9.66"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#f7bcb1",
    vectorEffect: "non-scaling-stroke",
    d: "M56.58 274.9q-.21.93.02.46"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#818181",
    vectorEffect: "non-scaling-stroke",
    d: "M56.6 275.36q-.28.65-.63.33"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#909396",
    vectorEffect: "non-scaling-stroke",
    d: "M55.97 275.69q-4.78 1.67-5.74 6.8"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#969da2",
    vectorEffect: "non-scaling-stroke",
    d: "M50.23 282.49q-2.42-.24-3.42 2.07-4.08 9.48-6.44 13.89"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#818181",
    vectorEffect: "non-scaling-stroke",
    d: "M40.37 298.45q-5.05 5.73-11.6 9.82-.78.5-1.29 2.41-.13.51-.56.83c-4.71 3.51-9.13 6.8-8.33 12.44a.96.93 66.5 0 1-.32.85q-1.89 1.62-1.46 3.96"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#95999d",
    vectorEffect: "non-scaling-stroke",
    d: "M16.81 328.76c-.44 5.95 4.15 7.02 9.06 7.67 9.85 1.32 20.99-1.44 29.88-5.7"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#818181",
    vectorEffect: "non-scaling-stroke",
    d: "m55.75 330.73 23.84-15.42"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#95999d",
    vectorEffect: "non-scaling-stroke",
    d: "M79.59 315.31c4.43-2.04 8.75-4.86 7.16-10.61"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#818181",
    vectorEffect: "non-scaling-stroke",
    d: "M86.75 304.7 86 294.07"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#ceae9c",
    vectorEffect: "non-scaling-stroke",
    d: "m86 294.07-1.17-7.43"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#818181",
    vectorEffect: "non-scaling-stroke",
    d: "m84.83 286.64-1.31-3.8"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#95999d",
    vectorEffect: "non-scaling-stroke",
    d: "M83.52 282.84q1.7-.23 1.98-2.84 1.22-11.54 5.03-31.13"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#909396",
    vectorEffect: "non-scaling-stroke",
    d: "m90.53 248.87 27.28-8.01"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#818181",
    vectorEffect: "non-scaling-stroke",
    d: "m117.81 240.86 9.24-3.45"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#95999d",
    vectorEffect: "non-scaling-stroke",
    d: "M127.05 237.41q2.45-3.27-.16-8.71"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#818181",
    vectorEffect: "non-scaling-stroke",
    d: "M126.89 228.7q.06-.12.13-.24"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#b39c90",
    vectorEffect: "non-scaling-stroke",
    d: "M127.02 228.46q13.19-.97 25.66 1.27"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#998d88",
    vectorEffect: "non-scaling-stroke",
    d: "m152.68 229.73 58.11 11.4"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#b39c90",
    vectorEffect: "non-scaling-stroke",
    d: "m210.79 241.13 6.26 21.29"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#ceae9c",
    vectorEffect: "non-scaling-stroke",
    d: "M217.05 262.42q3.01 10.34 6.28 21.03c1.36 4.46 5.54 4.31 9.08 2.51a.65.64 73.7 0 0 .35-.65l-5.18-45.02"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#b39c90",
    vectorEffect: "non-scaling-stroke",
    d: "m227.58 240.29-1.36-10.81q-.05-.47.42-.47l9.75-.17a1.15 1.14-83 0 0 1.09-.86q.99-3.89-.82-6.57"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#818181",
    vectorEffect: "non-scaling-stroke",
    d: "m236.66 221.41-5.39-9.74"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#dab59f",
    vectorEffect: "non-scaling-stroke",
    d: "m231.27 211.67 16.64-80.65"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#b39c90",
    vectorEffect: "non-scaling-stroke",
    d: "m247.91 131.02 1.32-6.29"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#dab59f",
    vectorEffect: "non-scaling-stroke",
    d: "M249.23 124.73q2.32.88 4.49.4.48-.11.73-.52 2.09-3.38.59-5.74"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#ebc2aa",
    vectorEffect: "non-scaling-stroke",
    d: "M255.04 118.87q-9.53-5.41-20.01-6.96"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#969da2",
    vectorEffect: "non-scaling-stroke",
    d: "M235.03 111.91q-2.32-6.54-2.57-13.5-.09-2.42-.75-4.57c-1.78-5.84 1.12-14.66-4.42-18.43q-7.11-4.85-16.6-9.08c-5.21-2.32-9.1-6.71-13.31-10.67"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#909396",
    vectorEffect: "non-scaling-stroke",
    d: "m197.38 55.66-4.59-3.8"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#ffcdbe",
    vectorEffect: "non-scaling-stroke",
    d: "M192.79 51.86q-1.23-1.2-1.69-4.19"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#f7bcb1",
    vectorEffect: "non-scaling-stroke",
    d: "m191.1 47.67-1.27-5.48"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#ffcdbe",
    vectorEffect: "non-scaling-stroke",
    d: "M189.83 42.19q4.32-6.16 2.12-13.34"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#9d8c8b",
    vectorEffect: "non-scaling-stroke",
    d: "M191.95 28.85c.61-5.88 3.05-12.81-.33-18.01-7.07-10.85-17.8-12.15-29.54-9.24-3.64.9-9.82.93-12.53 3.19q-1.99 1.66-7.49 8.72"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#9c5a4a",
    vectorEffect: "non-scaling-stroke",
    d: "M191.95 28.85q-5.13-4.35-7.97-.21c-2.37 3.46-1.52 9.56-1.38 13.95"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#95493d",
    vectorEffect: "non-scaling-stroke",
    d: "M182.6 42.59q4.74 4.6 1.92 11.17-4.97 11.55-17.29 15.43"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#9d8c8b",
    vectorEffect: "non-scaling-stroke",
    d: "M167.23 69.19q-4.17.88-8.24-2.57"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#887978",
    vectorEffect: "non-scaling-stroke",
    d: "m158.99 66.62-1.89-2.86q-.37-.55-.75-.01-8.19 11.69-13.98 24.08"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#5e595d",
    vectorEffect: "non-scaling-stroke",
    d: "m142.37 87.83-4.54 8.94"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#332a2e",
    vectorEffect: "non-scaling-stroke",
    d: "m137.83 96.77-.66-.01q-.58-.01-.39-.57 2.71-7.56 6.72-14.48c2.38-4.11 4.4-9.05 6.38-12.06 2.11-3.21 7.87-10.1 4.1-12.97"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#9c5a4a",
    vectorEffect: "non-scaling-stroke",
    d: "M154.33 56.16q.77-.56 2.36-2.22 1.09-1.15 6.55-2.46"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#6b3b28",
    vectorEffect: "non-scaling-stroke",
    d: "M163.24 51.48q2.83.37 5.03-.61"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#9c5a4a",
    vectorEffect: "non-scaling-stroke",
    d: "m168.27 50.87 5.41 2.52q.44.21.74-.17c4.09-5.21 4.12-12.85 3.1-19.41"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#95493d",
    vectorEffect: "non-scaling-stroke",
    d: "M177.52 33.81q-1.21-8.1-8.38-8.48"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#9c5a4a",
    vectorEffect: "non-scaling-stroke",
    d: "m169.14 25.33-4.19-3.45q-.36-.3-.84-.32l-3.82-.15"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#361a14",
    vectorEffect: "non-scaling-stroke",
    d: "m160.29 21.41-2.69-7.63q-.16-.44-.62-.5l-3.22-.44"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#522723",
    vectorEffect: "non-scaling-stroke",
    d: "M153.76 12.84q2.71-1.27 4.91.18c1.51 1 1.57 2.87 3.27 4.09a1.63 1.62 13.4 0 0 2.56-1.57q-.3-1.83-1.4-3.67c-.58-.96-1.59-1.62-2.02-3.06q-.17-.58-.77-.69l-1.61-.28q-.72-.13-.57-.85l.6-2.79q.06-.26-.2-.25c-8.01.24-10.21 3.77-14.65 9.45q-.56.72-1.82.11"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#f78a70",
    vectorEffect: "non-scaling-stroke",
    d: "m169.14 25.33 6.06 8.26q.28.38.74.34l1.58-.12"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#cd7c5b",
    vectorEffect: "non-scaling-stroke",
    d: "M168.27 50.87q-1.97-.68-5.03.61"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#804f40",
    vectorEffect: "non-scaling-stroke",
    d: "M149.03 41.75q1.44 1.56 2.79.71a1.16 1.16 0 0 0 .53-1.18q-.79-4.63-5.9-3.74M144.12 27.53l.12-5.21"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#cd7c5b",
    vectorEffect: "non-scaling-stroke",
    d: "M146.05 22.73q-.1.38.03.68.19.45.68.42l1.49-.11"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#576a73",
    vectorEffect: "non-scaling-stroke",
    d: "M137.83 96.77q-6.04 12.67-10.24 25.89"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#969da2",
    vectorEffect: "non-scaling-stroke",
    d: "m127.59 122.66-.64 2.83"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#516069",
    vectorEffect: "non-scaling-stroke",
    d: "m126.95 125.49-.21.14q-.23.16-.29-.11l-6.79-33.24"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#576a73",
    vectorEffect: "non-scaling-stroke",
    d: "m119.66 92.28-.95-5.52"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#273138",
    vectorEffect: "non-scaling-stroke",
    d: "m118.71 86.76 4.95-17.01a.92.92 0 0 0-1.61-.82q-2.12 2.74-5.14 1.01"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#f78a70",
    vectorEffect: "non-scaling-stroke",
    d: "M189.83 42.19q-1.14-.15-1.99.64a1.13 1.11-62.2 0 1-.91.29l-4.33-.53"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#ebecec",
    vectorEffect: "non-scaling-stroke",
    d: "m186.18 81.49-1.29-.06q-.45-.02-.71.36-3.65 5.4-7.67 10.56c-.63.81-.92 1.99-1.87 2.84-1.67 1.51-2.24 2.11-1.85 4.29q.11.59-.37.97l-1.72 1.35q-.41.32-.45.84-.18 2.15 1.2 3.73a1.41 1.41 0 0 0 .86.48q1.32.2 2.5.97"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#909396",
    vectorEffect: "non-scaling-stroke",
    d: "m169.56 121.2-4.4 16.23"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#ffcdbe",
    vectorEffect: "non-scaling-stroke",
    d: "M165.16 137.43c-7.31-2.93-15.41-8.92-23.94-9.34-4.59-.23-9.24-.56-13.22.92"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#bbc2c6",
    vectorEffect: "non-scaling-stroke",
    d: "M128 129.01c-1.9.4-.93-2.49-1.05-3.52"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#c1ccd1",
    vectorEffect: "non-scaling-stroke",
    d: "m127.59 122.66 1.46-.2q.47-.06.47-.53-.01-1.99 1.73-2.94.46-.25.62-.74l.25-.73q.14-.4.53-.53c4.2-1.39 3.58-4.4 4.59-7.34q1.21-3.54 1.48-7.58"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#4e2820",
    vectorEffect: "non-scaling-stroke",
    d: "m153.76 12.84-4.36 4.89q-.62.7-.61-.23.03-2.36 1.02-4.48a.84.84 0 0 0-1.41-.88c-1.87 2.29-4.83 6.8-2.89 9.88"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#b46856",
    vectorEffect: "non-scaling-stroke",
    d: "M145.51 22.02q-.79-.17-1.27.3"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#361c19",
    vectorEffect: "non-scaling-stroke",
    d: "M144.24 22.32q-.35-3.14-1.88-2.84"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#ebecec",
    vectorEffect: "non-scaling-stroke",
    d: "M158.99 66.62q-4.47 9.46-10.3 18.11-.29.44-.21.96c.24 1.65-1.14 2.36-1.6 3.3q-2.62 5.32-3.6 11.19-.29 1.69-1.37 3.78c-1.37 2.65-.88 5.8-2.89 7.87a1.43 1.35-21 0 0-.39.82q-.48 4.52-2.43 8.62a.97.95 6 0 1-.68.54l-3.08.63q-.38.07-.18-.26l4.04-6.56q.29-.46.32-1.01c.1-1.57 1.09-2.46 1.34-3.78q.8-4.37.76-8.76"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#acb9be",
    vectorEffect: "non-scaling-stroke",
    d: "m138.72 102.07 3.65-14.24"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#985b47",
    vectorEffect: "non-scaling-stroke",
    d: "M160.29 21.41q-2.99-.81-4.27-2.01a1.15 1.15 0 0 0-1.82.35q-1.4 2.98-4.55 4.09-.4.14-.81.03l-.59-.15"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#673b25",
    vectorEffect: "non-scaling-stroke",
    d: "M148.25 23.72q-1.05-1.03-2.2-.99"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#985b47",
    vectorEffect: "non-scaling-stroke",
    d: "m146.05 22.73-.54-.71"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#f78a70",
    vectorEffect: "non-scaling-stroke",
    d: "M191.1 47.67q-3.37 2.4-3.03 6.78a1.91 1.87 55.7 0 1-.17.95q-1.77 3.72-2.94 7.63c-.71 2.42-2.17 4.16-3.17 6.49-1.03 2.42-7.26 6.92-9.97 5.98-2.68-.93-1.56-4.21-3.06-4.79"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#f7bcb1",
    vectorEffect: "non-scaling-stroke",
    d: "M168.76 70.71q.11-1.22-1.53-1.52"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#525f67",
    vectorEffect: "non-scaling-stroke",
    d: "m118.71 86.76-1.17-3.71"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#7c8083",
    vectorEffect: "non-scaling-stroke",
    d: "M117.54 83.05q.45-2.91-1.2-5.6-.28-.47-.82-.51l-6.17-.51"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#7c8e98",
    vectorEffect: "non-scaling-stroke",
    d: "M119.66 92.28c-6.77-1.25-9.85 4.14-14.11 7.77q-2.97 2.53-5.04 4.7-4 4.19-7.69 5.94"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#57656e",
    vectorEffect: "non-scaling-stroke",
    d: "M92.82 110.69q-2.06-2.16-3.56-2.21"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#ba9085",
    vectorEffect: "non-scaling-stroke",
    d: "M128 129.01q-.61 1 .16 1.55"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#a6afb3",
    vectorEffect: "non-scaling-stroke",
    d: "M128.16 130.56q-.68.99-.72 1.67"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#4c555d",
    vectorEffect: "non-scaling-stroke",
    d: "m127.44 132.23-21.79-.07"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#475058",
    vectorEffect: "non-scaling-stroke",
    d: "m105.65 132.16-5.7-9.39"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#515b64",
    vectorEffect: "non-scaling-stroke",
    d: "m99.95 122.77-7.13-12.08"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#906155",
    vectorEffect: "non-scaling-stroke",
    d: "m180.05 141.53-14.89-4.1"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#f78a70",
    vectorEffect: "non-scaling-stroke",
    d: "M179.8 141.64q-1 6.99-7.35 8.37-.28.06-.5.23l-.25.21q-.36.29-.74.04l-3.91-2.52q-.28-.18-.5-.43-1.21-1.44-3.8-2-5.43-1.17-8.82.27"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#9f7268",
    vectorEffect: "non-scaling-stroke",
    d: "M148.25 142.16q-3.96-3.41-8.85-5.06"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#eabaab",
    vectorEffect: "non-scaling-stroke",
    d: "m139.4 137.1-11.24-6.54"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#906155",
    vectorEffect: "non-scaling-stroke",
    d: "M192.79 51.86c.54 3.76 2.74 8.06.45 11.59"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#ffcdbe",
    vectorEffect: "non-scaling-stroke",
    d: "M193.24 63.45q-6.32 11.62-18.08 13.05c-3.92.48-8.34-.63-6.4-5.79"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#82604c",
    vectorEffect: "non-scaling-stroke",
    d: "m235.03 111.91-1.57 5.71"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#644c3f",
    vectorEffect: "non-scaling-stroke",
    d: "m233.46 117.62-1.1 3.61"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#969da2",
    vectorEffect: "non-scaling-stroke",
    d: "m232.36 121.23-.09 11.65"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#644c3f",
    vectorEffect: "non-scaling-stroke",
    d: "M232.27 132.88c.45 12.1-.93 21.4-6.72 31.67"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#969da2",
    vectorEffect: "non-scaling-stroke",
    d: "m225.55 164.55-.57.52"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#273138",
    vectorEffect: "non-scaling-stroke",
    d: "M224.98 165.07q.84-2.59-.54-4.78a1.1 1.09 37.8 0 1-.12-.91q2.02-6.74-3.68-10.33a1.78 1.78 0 0 0-2.66 1.02l-2.34 8.22a.35.35 0 0 1-.55.18l-5.66-4.36a1.06 1.06 0 0 0-1.53 1.42q4.38 6.68 9.7 12.57.37.41.92.33l4.4-.62"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#969da2",
    vectorEffect: "non-scaling-stroke",
    d: "M222.92 167.81q-1.91 6.45-.55 12.37"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#644c3f",
    vectorEffect: "non-scaling-stroke",
    d: "m222.37 180.18.2 5.25"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#415761",
    vectorEffect: "non-scaling-stroke",
    d: "M222.57 185.43c-7.36-3.79-20.25-5.53-27.67-5.4"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#222c33",
    vectorEffect: "non-scaling-stroke",
    d: "M194.9 180.03q-2.93-6.37 4.79-11.53c2.85-1.9 12.74-9.22 5.42-11.78-2.76-.96-6.65 2.15-8.54 3.99-5.15 5.03-9.24 9.32-16 9.16-4.65-.11-8.32-2.7-10.07-6.95a.54.53-3.9 0 1 .63-.72q.19.05.39.05.26-.01.39.21c4.08 6.91 12.86 6.79 17.96 1.43q.27-.27-.11-.33l-12.93-2.09a1 1 0 0 1-.49-1.75l2.28-1.97a.49.48-44.6 0 0 .01-.72q-.14-.13-.46-.12"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#8e5a53",
    vectorEffect: "non-scaling-stroke",
    d: "M178.17 156.91c3.52-2.08 2.64-12.09 1.63-15.27"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#956b61",
    vectorEffect: "non-scaling-stroke",
    d: "M179.8 141.64q.13-.06.25-.11"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#273138",
    vectorEffect: "non-scaling-stroke",
    d: "M180.05 141.53c-.96-2.04-2.44-6.07-5.34-5.51a.39.39 0 0 1-.42-.56q.6-1.19 2.22-1.03c11.07 1.07 21.86 3.39 32.94 4.25a2.26 2.2-26.6 0 1 .98.31q2.62 1.55 5.58.8a.31.31 0 0 0-.03-.61q-1.79-.25-3.39-.97-2.52-1.13-.15-2.53c3.07-1.81 5.58-4.31 8.43-6.77q1.92-1.65.6-4.21a1.08 1.07 82.3 0 0-.7-.54c-5.02-1.15.56-9.4 1.97-11.52a1.02 1.02 0 0 0 .02-1.11q-3.17-5.14-8.57-2.27a1.26 1.26 0 0 1-1.84-1.25q.68-6.02 3.81-11.32a1.07 1.07 0 0 0 .08-.92l-.52-1.38a.18.17 48.4 0 0-.32-.02l-6.41 12.59q-.22.43-.69.54-.87.2-1.16.98-.16.41-.46.72l-2.23 2.23a1.64 1.55 15.2 0 1-.8.43q-2.22.47-4.08 1.7-.64.43-.82-.32l-.47-2.07a1.43 1.42-78.5 0 0-.54-.82q-1.45-1.08-3-2-.38-.22-.45-.66-.23-1.41.38-2.76 5.08-11.4 10.39-22.27a.44.44 0 0 0-.75-.45q-3.47 4.69-7.11 9.16c-.53.65-.51 1.48-.99 2.11-4.42 5.83-8.16 12.28-12.9 17.52q-4.58 5.06-9.23 10.07c-1.53 1.65-2.94 1.59-4.52.13"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#969da2",
    vectorEffect: "non-scaling-stroke",
    d: "m169.56 121.2 5.25-13.38"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#818a8f",
    vectorEffect: "non-scaling-stroke",
    d: "m174.81 107.82 11.37-26.33"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#969da2",
    vectorEffect: "non-scaling-stroke",
    d: "m186.18 81.49 3.21-7.72"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#273138",
    vectorEffect: "non-scaling-stroke",
    d: "M197.38 55.66q-2.5 11.08-3.77 14.65-.94 2.65-4.22 3.46"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#909396",
    vectorEffect: "non-scaling-stroke",
    d: "m189.39 73.77 3.85-10.32"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#acb9be",
    vectorEffect: "non-scaling-stroke",
    d: "M117.54 83.05q-9.23 5.85-16.41 14.31c-1.86 2.19-4.35 3.51-6.35 5.69q-2.19 2.36-2.67 2.82-1.47 1.38-2.85 2.61"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#81868a",
    vectorEffect: "non-scaling-stroke",
    d: "M89.26 108.48q-12.25-4.61-22.32 3.21-.37.28-.89-.19"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#b99b89",
    vectorEffect: "non-scaling-stroke",
    d: "M66.05 111.5q-.1-.22-.27-.32"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#d7af97",
    vectorEffect: "non-scaling-stroke",
    d: "m65.78 111.18-.77-3.97"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#22272e",
    vectorEffect: "non-scaling-stroke",
    d: "m99.95 122.77-1.14 5.57"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#363d47",
    vectorEffect: "non-scaling-stroke",
    d: "M98.81 128.34c-1.94-2.69-5.78-8.6-9.05-9.15a.41.41 0 0 0-.38.66l8.38 10.43a.47.47 0 0 1-.48.76c-1.71-.43-3.65 2.75-4.53 4.01-2 2.86-.32 9.93.75 13.04.35 1.05 1.24 1.89 1.26 3.35q.01.51.37.87 7.21 7.29 12.3 16.18a.8.8 0 0 1-1.2 1.01q-5.33-4.32-10.85-8.36-8.43-6.16-1.28 1.44c1.89 2.01 13.23 9.25 13.11 11.62q-.02.62-.49.22-4.03-3.45-8.95-5.44a.81.8-65.2 0 0-1.02.38c-1.71 3.39-.71 6.04 2.4 8.21 3.5 2.43 8.65 5.34 10.42 9.37a.72.72 0 0 1-1.19.77c-1.81-1.97-7.89-7.8-10.93-6.53a.63.62 72.6 0 0-.37.71q.38 1.73 2 2.55.47.24.61.75.16.59.05 1.3"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#95675c",
    vectorEffect: "non-scaling-stroke",
    d: "M99.74 186.49q-7.85-.47-12.01 5.52"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#171a1f",
    vectorEffect: "non-scaling-stroke",
    d: "M87.73 192.01q-3.04.97-4.98 5.58"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#262c33",
    vectorEffect: "non-scaling-stroke",
    d: "M82.75 197.59q-1.09.73-1.88.65"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#22272e",
    vectorEffect: "non-scaling-stroke",
    d: "m80.87 198.24-12.25-41.36q-.09-.31-.36-.48-.16-.1-.3-.24"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#64473a",
    vectorEffect: "non-scaling-stroke",
    d: "M67.96 156.16q.5-.42.3-1.16c-3.18-11.99-6.7-22.91-6.2-34.49"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#49362e",
    vectorEffect: "non-scaling-stroke",
    d: "m62.06 120.51 1.55-6.15"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#64473a",
    vectorEffect: "non-scaling-stroke",
    d: "M63.61 114.36q1.79-.97 2.44-2.86"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#8b9196",
    vectorEffect: "non-scaling-stroke",
    d: "M139.4 137.1c.47.43 2.75 1.96.8 2.2"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#7c8083",
    vectorEffect: "non-scaling-stroke",
    d: "m140.2 139.3-12.76-7.07"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#313740",
    vectorEffect: "non-scaling-stroke",
    d: "m140.2 139.3 3.82 3.07"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#1d2127",
    vectorEffect: "non-scaling-stroke",
    d: "m105.65 132.16 8.98 13.66q.42.63-.31.84l-3.67 1.06q-.58.17-.41.75.36 1.21 1.31 2.09.38.35.55.85c1.63 4.85 4.09 9.37 3.57 14.84q-.05.52.34.87 1.46 1.34 2.67 2.9c3.5 4.5 1.3 14.19 8.99 15.24a.34.33 1.2 0 1 .28.29c.16 1.38 11.22 1.31 12.74 1.53 7.23 1.09 13.01-3.41 18.48-5.81 3.54-1.55 4.95-3.63 3.44-7.37a1.33 1.32 3.3 0 0-.62-.69c-3.87-2.09-5.49-1.43-8.27-5.32q-.28-.39-.71-.61c-2.5-1.27-4.96-.97-7.3-2q-4.28-1.86-8.55-3.89a1.59 1.59 0 0 1 .35-2.99l8.02-1.68a.98.97 65.2 0 0 .57-1.55c-1.74-2.26-4.28-1.94-6.14-2.87q-1.74-.88-3.36-1.97c-2.55-1.71-5.28-1.94-8.05-3.26a.95.94-78 0 1-.54-.84q0-.62-.7-.84a.79.79 0 0 1 .17-1.54l16.54-1.48"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#2c323b",
    vectorEffect: "non-scaling-stroke",
    d: "M144.02 142.37q1.56.82 4.23-.21"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#8b5c50",
    vectorEffect: "non-scaling-stroke",
    d: "m148.25 142.16 5.68 3.65"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#844a42",
    vectorEffect: "non-scaling-stroke",
    d: "M153.93 145.81c4.42 1.83 8.6 2.62 12.65 4.96q5.7 3.3 11.59 6.14"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#374750",
    vectorEffect: "non-scaling-stroke",
    d: "M194.9 180.03q-10.72 3.78-27.9 7.45c-22.77 4.86-35.85 7.51-56.48 8.71"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#8b5c50",
    vectorEffect: "non-scaling-stroke",
    d: "m110.52 196.19-1.79-4.35"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#6c8590",
    vectorEffect: "non-scaling-stroke",
    d: "m222.72 186.41-3.51 6.47q-.25.45-.71.67-4.59 2.22-9.71 2.59a.75.75 0 0 0-.41 1.34c1.52 1.19 9.51.64 11.5.27q.48-.1.84.25 2.07 1.99 4.79 2.16"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#4a6570",
    vectorEffect: "non-scaling-stroke",
    d: "M225.51 205.78q-1.21-1.33-1.35-3.29-.05-.6-.64-.56-1.59.1-2.08-1.21-.19-.51-.73-.6c-3.73-.6-7.41.77-10.82 1.18-3.03.37-5.32 1.86-8.14 2.45q-7.53 1.58-13.29 6.16a1.81 1.81 0 0 1-.86.37q-4.92.72-8.83 3.63a1.73 1.68 25 0 1-.95.33q-1.69.05-2.6 1.42-.3.44-.74.73l-2.62 1.71q-.4.26-.43.73-.16 2.11-3.49 2.93"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#5f564f",
    vectorEffect: "non-scaling-stroke",
    d: "M167.94 221.76q-20.78 1.31-42.39.43"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#2c3a40",
    vectorEffect: "non-scaling-stroke",
    d: "M125.55 222.19q-1.42-5.08-5.14-9.13"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#41525c",
    vectorEffect: "non-scaling-stroke",
    d: "m120.41 213.06-2.72-1.81"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#3c4c55",
    vectorEffect: "non-scaling-stroke",
    d: "m117.69 211.25-2.47-1.67"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#aa877d",
    vectorEffect: "non-scaling-stroke",
    d: "M115.22 209.58q.68-.59.47-1.02-2.99-5.92-5.17-12.37"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#c6774a",
    vectorEffect: "non-scaling-stroke",
    d: "m255.04 118.87-1.08.18q-.16.03-.19.18l-.04.29q-.04.21-.26.2l-14.7-.6"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#ba7047",
    vectorEffect: "non-scaling-stroke",
    d: "M238.77 119.12q-2.76-1.69-5.31-1.5"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#909396",
    vectorEffect: "non-scaling-stroke",
    d: "M224.98 165.07q-1.6 1.46-2.06 2.74"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#b39c90",
    vectorEffect: "non-scaling-stroke",
    d: "m234.81 122.48-1.12 4.73"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#ceae9c",
    vectorEffect: "non-scaling-stroke",
    d: "M233.69 127.21q-.13 3.18-1.42 5.67"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#a9633c",
    vectorEffect: "non-scaling-stroke",
    d: "M238.77 119.12q.76 1.55-.65 4.33"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#824b2d",
    vectorEffect: "non-scaling-stroke",
    d: "M238.12 123.45q-1.7-1.45-3.31-.97"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#ceae9c",
    vectorEffect: "non-scaling-stroke",
    d: "M234.81 122.48q-.77-1.1-2.45-1.25"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#8f7a6e",
    vectorEffect: "non-scaling-stroke",
    d: "m224.87 192.77-2.15-6.36"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#79675b",
    vectorEffect: "non-scaling-stroke",
    d: "M222.72 186.41q-.19-.47-.15-.98"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#ceae9c",
    vectorEffect: "non-scaling-stroke",
    d: "M222.37 180.18q2.41-7.6 3.18-15.63"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#824b2d",
    vectorEffect: "non-scaling-stroke",
    d: "M63.61 114.36q-4.16-.56-7.16.48"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#ceae9c",
    vectorEffect: "non-scaling-stroke",
    d: "M56.45 114.84q-4.82-.76-9.79.59"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#824b2d",
    vectorEffect: "non-scaling-stroke",
    d: "M46.66 115.43q-4.07-.58-8.77 1.09"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#ceae9c",
    vectorEffect: "non-scaling-stroke",
    d: "M37.89 116.52q-1.57-.54-3.94.23"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#824b2d",
    vectorEffect: "non-scaling-stroke",
    d: "m33.95 116.75-8.38 1.78"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#ceae9c",
    vectorEffect: "non-scaling-stroke",
    d: "M25.57 118.53q-.76-.25-1.32.96"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#824b2d",
    vectorEffect: "non-scaling-stroke",
    d: "M24.25 119.49q-4.24.24-5.93 2.67"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#ceae9c",
    vectorEffect: "non-scaling-stroke",
    d: "M18.32 122.16q-.53-1.13-1.66.4"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#824b2d",
    vectorEffect: "non-scaling-stroke",
    d: "m16.66 122.56-8.41-.09"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#ba7047",
    vectorEffect: "non-scaling-stroke",
    d: "M65.78 111.18c-12.27.71-28.27 1.64-41.6 4.55-2.23.48-6.83 3.17-8.43 2.97q-6.32-.78-12.68-.89-1.03-.02-2.07-1.42"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#2c323b",
    vectorEffect: "non-scaling-stroke",
    d: "M98.81 128.34c2.15 4.8 5.77 9.25 7.52 14.09 1.65 4.52 3.19 8.34 3.61 13.16.65 7.52.43 15.22 1.14 22.53q.73 7.47 1.06 15.13a.54.54 0 0 1-1.04.21l-.62-1.6q-.23-.6-.83-.37l-.92.35"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#9f7268",
    vectorEffect: "non-scaling-stroke",
    d: "M108.73 191.84q-3.28-4.84-8.99-5.35"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#824b2d",
    vectorEffect: "non-scaling-stroke",
    d: "M62.06 120.51c-4.09-1.42-1.24 6.72-1.41 8.63-.32 3.46.54 7.57.71 10.15q.64 9.91 1.84 19.77.04.37.42.42.22.03.45.15"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#402b22",
    vectorEffect: "non-scaling-stroke",
    d: "M64.07 159.63 63 161.17"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#5f564f",
    vectorEffect: "non-scaling-stroke",
    d: "m63 161.17-2.92 1.26"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#b39c90",
    vectorEffect: "non-scaling-stroke",
    d: "m60.08 162.43-3.63-47.59"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#121418",
    vectorEffect: "non-scaling-stroke",
    d: "M114.52 209.31q.09.51-.11.85-.29.49-.79.21l-2.86-1.56"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#171a1f",
    vectorEffect: "non-scaling-stroke",
    d: "M110.76 208.81q-1.86-2.1-3.74-1.76-.57.1-.72.66l-2.08 7.83"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#121418",
    vectorEffect: "non-scaling-stroke",
    d: "M104.22 215.54q-.69.67-.7 1.34-.01.52.5.65 6.19 1.59 9.89 6.77a1.18 1.18 0 0 0 1.98-1.29q-1.1-1.87-.37-3.3"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#793d33",
    vectorEffect: "non-scaling-stroke",
    d: "m115.52 219.71 3.39 5.04q.29.44.66.06c.46-.49-2.34-6.45-2.67-7.16"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#171a1f",
    vectorEffect: "non-scaling-stroke",
    d: "M116.9 217.65q1.88 1.06 3.51-4.59"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#351e12",
    vectorEffect: "non-scaling-stroke",
    d: "m125.55 222.19 1.47 6.27"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#171a1f",
    vectorEffect: "non-scaling-stroke",
    d: "m126.89 228.7-2.25.43q-.53.1-.56.63-.32 5.18 2.97 7.65"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#121418",
    vectorEffect: "non-scaling-stroke",
    d: "M117.81 240.86q-4.65-5.11-12.56-4.36c-4.46.42-16.41 3.6-16.92 9.54q-.04.44.38.59 1.01.36.36 1.95"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#171a1f",
    vectorEffect: "non-scaling-stroke",
    d: "M89.07 248.58q-2.26-1.13-3.78-4.7M89.86 218.28q-1.69-5.62 1.87-10.26.29-.38.06-.81-.25-.46-.76-.72"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#5a3c2e",
    vectorEffect: "non-scaling-stroke",
    d: "m67.96 156.16-3.89 3.47"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#906155",
    vectorEffect: "non-scaling-stroke",
    d: "m115.22 209.58-.7-.27"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#804f40",
    vectorEffect: "non-scaling-stroke",
    d: "M114.52 209.31q-5.07-4.46-11.67-4.02-.5.03-.9-.28c-2.76-2.15-6.01.33-8.48 1.83q-.45.28-.69-.2c-1.96-3.92-5.81-10.36-5.05-14.63"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#121418",
    vectorEffect: "non-scaling-stroke",
    d: "M82.75 197.59c.6 6.05 6.11 1.77 7.25 6.57q.11.49.52.79.87.65.51 1.54"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#262c33",
    vectorEffect: "non-scaling-stroke",
    d: "M91.03 206.49q-1.62-.68-2.21 1.02a.42.42 0 0 1-.54.26c-1.52-.52-3.58-1.3-2.75 1.57q1.4 4.88 3.09 9.52a.62.61-51.5 0 0 1.19-.14l.05-.44"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#121418",
    vectorEffect: "non-scaling-stroke",
    d: "M89.86 218.28c2.15 9.97-9.4 15.89-4.57 25.6"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#262c33",
    vectorEffect: "non-scaling-stroke",
    d: "M85.29 243.88q-1.32.24-1.52 1.47-.09.52.24.93c.73.91.08 4.76-.21 7.02a1.39 1.35-18.3 0 1-.45.86c-2.09 1.87-3.49 3.2-3.68 6.23q-.33 5.16-.12 10.34a1.84 1.83-62.6 0 0 .29.92q1.2 1.81 1.5 3.91"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#121418",
    vectorEffect: "non-scaling-stroke",
    d: "M81.34 275.56q-.73-.07-.19.45"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#884f47",
    vectorEffect: "non-scaling-stroke",
    d: "M81.15 276.01q-4.4-4.79-10.59-7.58c-3.9-1.75-10.49-1.93-12.45 2.6-.19.42-.7 4.41-1.53 3.87"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#2a201f",
    vectorEffect: "non-scaling-stroke",
    d: "M53.04 235.02q1.71-4.09 1.14-10.08"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#443027",
    vectorEffect: "non-scaling-stroke",
    d: "m54.18 224.94.48-5.77q.04-.51-.45-.6-16.75-3.27-33.71-4.76-.72-.06-1-1.62"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#2f3f48",
    vectorEffect: "non-scaling-stroke",
    d: "M22.6 209.5c1.67 1.04 3.3 1.95 5.32 2.35q11.93 2.38 25.41 5.19 1.86.39 2.08-1.5l2.77-23.69"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#1d2127",
    vectorEffect: "non-scaling-stroke",
    d: "M80.87 198.24q.71 4.72 5.22 5.26a1.1 1.09 47.2 0 1-.08 2.18l-1.89.08q-.47.02-.84-.28l-2.73-2.24q-.41-.34-.61-.84c-4.61-11.87-6.91-24.26-14.13-37.15-.82-1.46-2.02-2.02-3.11-3.31"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#374750",
    vectorEffect: "non-scaling-stroke",
    d: "M62.7 161.94q.35-.22.3-.77"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#8d554e",
    vectorEffect: "non-scaling-stroke",
    d: "m116.9 217.65-3.05-2.45"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#8e5230",
    vectorEffect: "non-scaling-stroke",
    d: "M247.91 131.02q-1.88.15-4.46-1.42a1.32 1.31-56.9 0 0-1.77.38q-.78 1.13-1.05 2.49-3.45 17-7.4 33.89c-2.51 10.71-5.01 21.67-6.46 32.6q-.07.5-.43.86-.37.35-.82.46"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#5f564f",
    vectorEffect: "non-scaling-stroke",
    d: "M225.52 200.28q0-.06-.01-.12"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#756962",
    vectorEffect: "non-scaling-stroke",
    d: "m225.51 200.16-.64-7.39"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#824b2d",
    vectorEffect: "non-scaling-stroke",
    d: "M224.87 192.77c1.29-2.88 1.35-6.53 1.81-8.69q2.96-13.93 6.02-27.84 2.69-12.21 5.11-24.48.22-1.12.61-1.41a1.73 1.61-61.3 0 0-.78-3.07l-3.95-.07"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#5c3621",
    vectorEffect: "non-scaling-stroke",
    d: "M231.27 211.67c-1.78 3.76-1.52 6.4-7.2 4.38"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#796151",
    vectorEffect: "non-scaling-stroke",
    d: "M224.07 216.05q1.65-5.03 1.44-10.27"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#866e5e",
    vectorEffect: "non-scaling-stroke",
    d: "m225.51 205.78.01-5.5"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#824b2d",
    vectorEffect: "non-scaling-stroke",
    d: "M227.58 240.29c-3.8-.53-5.35 1.07-4.94 4.87.64 5.92.55 14.45-5.59 17.26"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#4d2a19",
    vectorEffect: "non-scaling-stroke",
    d: "M210.79 241.13q4.18.53 7.74-.46.5-.14.44-.65c-.37-3.05-1.89-7.37-1.37-10.28q.09-.49-.41-.54-1.98-.2-3.94-.26-28.38-.79-56.76-.14c-1.18.03-3.76-1.2-3.81.93"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#202d33",
    vectorEffect: "non-scaling-stroke",
    d: "M224.07 216.05q-.61 2.33-3.45 5.24"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#524942",
    vectorEffect: "non-scaling-stroke",
    d: "m220.62 221.29-52.68.47"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#262c33",
    vectorEffect: "non-scaling-stroke",
    d: "M117.69 211.25q-2.97 1.14-3.84 3.95"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#884f47",
    vectorEffect: "non-scaling-stroke",
    d: "M113.85 215.2q-.44.51-.57 1.01-.12.5.25.85 1.58 1.5 1.99 2.65"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#8e5230",
    vectorEffect: "non-scaling-stroke",
    d: "M249.23 124.73q-5.99.61-11.11-1.28"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#abb9be",
    vectorEffect: "non-scaling-stroke",
    d: "m60.08 162.43-8.39 4.77"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#ceae9c",
    vectorEffect: "non-scaling-stroke",
    d: "m51.69 167.2-4.28-43.31"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#b39c90",
    vectorEffect: "non-scaling-stroke",
    d: "m47.41 123.89-.75-8.46"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#824b2d",
    vectorEffect: "non-scaling-stroke",
    d: "M25.04 124.19q-2.57.27-3.77 2.5-.21.39-.06.8c1.3 3.52 1.66 7.58 2.49 10.94.82 3.34 1.01 7.23 1.52 10.08q2.51 13.89 5.18 27.7"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#756962",
    vectorEffect: "non-scaling-stroke",
    d: "M30.4 176.21q-1.3 1.65-1.89 1.07"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#b39c90",
    vectorEffect: "non-scaling-stroke",
    d: "m28.51 177.28-10.19-55.12"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#abb9be",
    vectorEffect: "non-scaling-stroke",
    d: "M35.06 174.47q-2.05 2.84-1.57.8"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#ceae9c",
    vectorEffect: "non-scaling-stroke",
    d: "m33.49 175.27-8.45-51.08"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#b39c90",
    vectorEffect: "non-scaling-stroke",
    d: "m25.04 124.19-.79-4.7"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#824b2d",
    vectorEffect: "non-scaling-stroke",
    d: "m34.89 123.52-4.69 1.61a1.62 1.62 0 0 0-1.06 1.83l8.97 46.81"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#5f564f",
    vectorEffect: "non-scaling-stroke",
    d: "M38.11 173.77q-.92 1.04-3.05.7"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#b39c90",
    vectorEffect: "non-scaling-stroke",
    d: "m35.06 174.47-9.49-55.94"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#824b2d",
    vectorEffect: "non-scaling-stroke",
    d: "M47.41 123.89q-4.87-2.6-5.78 1.7a2.11 2.04-44.1 0 0-.02.64l6.07 43.54"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#5f564f",
    vectorEffect: "non-scaling-stroke",
    d: "M47.68 169.77q-1.79 1.07-3.5.97"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#b39c90",
    vectorEffect: "non-scaling-stroke",
    d: "m44.18 170.74-6.29-54.22"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#c1ccd1",
    vectorEffect: "non-scaling-stroke",
    d: "M28.51 177.28q-.3.53-1.19.76"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#ceae9c",
    vectorEffect: "non-scaling-stroke",
    d: "m27.32 178.04-9.75-50.32"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#b39c90",
    vectorEffect: "non-scaling-stroke",
    d: "m17.57 127.72-.91-5.16"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#824b2d",
    vectorEffect: "non-scaling-stroke",
    d: "M17.57 127.72q-4.91.57-4.53 5.28.76 9.47 4.65 19.96a.86.85-36.3 0 1-.13.83c-1.24 1.58 5.48 23.25 5.46 27.57q0 .54.52.63.54.1 1.14-.29"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#756962",
    vectorEffect: "non-scaling-stroke",
    d: "M24.68 181.7q-.12.97-.98 1.61"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#524942",
    vectorEffect: "non-scaling-stroke",
    d: "M23.7 183.31q-.88 1.84-2.07 2.84"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#abb9be",
    vectorEffect: "non-scaling-stroke",
    d: "M44.18 170.74q-.5 1.75-2.87 2.02"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#ceae9c",
    vectorEffect: "non-scaling-stroke",
    d: "m41.31 172.76-6.42-49.24"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#b39c90",
    vectorEffect: "non-scaling-stroke",
    d: "m34.89 123.52-.94-6.77"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#3c4c55",
    vectorEffect: "non-scaling-stroke",
    d: "M62.7 161.94q-.93 1.07-1.01 1.56-2.36 13.97-3.51 28.35"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#4a6570",
    vectorEffect: "non-scaling-stroke",
    d: "m58.18 191.85-16.75-3.74"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#6c8590",
    vectorEffect: "non-scaling-stroke",
    d: "M41.43 188.11q.4-.75.33-1.49-.05-.45-.48-.56c-2.04-.55-8.91-2.09-10.75-4.14q-.3-.33-.27-.78.16-3.05 2.43-4.8.45-.34-.11-.38l-.36-.02"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#262c33",
    vectorEffect: "non-scaling-stroke",
    d: "m110.76 208.81-1.4 6.31a1.53 1.52-64.2 0 1-2.45.86q-.9-.73-2.69-.44M90.53 248.87q-.39.33-1.46-.29"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#171a1f",
    vectorEffect: "non-scaling-stroke",
    d: "M83.52 282.84q.23-3.63-2.18-7.28"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#121418",
    vectorEffect: "non-scaling-stroke",
    d: "M70.47 287.09c-4.5-2.06-5.35.41-7.71 3.08q-8.71 9.82-17.77 19.32-1.58 1.65-2.66 5.08c-.76 2.4.47 5.45-3.72 6.08a1.84 1.83 22 0 0-.83.35c-3.34 2.59-6.2 2.95-8.76 7.04q-.24.4-.66.59l-.73.34q-.8.37.08.49 11.16 1.45 19.77-3.44 1.43-.81 2.48-1.17c6.01-2.04 11.91-6.94 13.76-11.95a.76.76 0 0 0-.39-.95q-4.88-2.31-8.19 2.22-3.14 4.3-10.25 6.33-.42.12-.56-.3-.52-1.65 1.18-2.24c2.63-.91 3.53-3.04 5.75-4.34q.47-.28.28-.79l-.52-1.39a.78.78 0 0 1 .99-1c5.2 1.87 2.59-3.97 6.39-3.43a.54.54 0 0 0 .59-.4q.37-1.29 2.09-1.15"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#361c19",
    vectorEffect: "non-scaling-stroke",
    d: "m61.08 305.46 3.12 3.62"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#793d33",
    vectorEffect: "non-scaling-stroke",
    d: "m64.2 309.08 2.11 2.72"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#361c19",
    vectorEffect: "non-scaling-stroke",
    d: "m66.31 311.8 2.65 5.06q.27.51.71.14c2.83-2.37.6-6.07-1.15-8.48"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#793d33",
    vectorEffect: "non-scaling-stroke",
    d: "M68.52 308.52q-.52-1.36-1.81-2.41"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#361c19",
    vectorEffect: "non-scaling-stroke",
    d: "m66.71 306.11-3.77-4.61"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#121418",
    vectorEffect: "non-scaling-stroke",
    d: "M62.94 301.5q1.03-1.36 3.43-.94c5.81 1.01 5.98 10.81 13.83 6.4q3.38-1.9 2.61-5.74-.1-.5-.61-.52c-4.61-.13-11.95-1.46-14.22-5.84q-.2-.4.03-.78l1.5-2.43a.81.81 0 0 1 1.49.53l-.3 2.22a.98.97-70.6 0 0 .46.97q3.14 1.87 6.76 1.25a1.2 1.2 0 0 0-.12-2.38q-2.93-.2-2.77-2.06"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#4f2f1e",
    vectorEffect: "non-scaling-stroke",
    d: "M84.83 286.64q-1.56 1.76-2.05 3.67a.84.84 0 0 0 .23.81l2.99 2.95"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#171a1f",
    vectorEffect: "non-scaling-stroke",
    d: "M86.75 304.7 77 312.06q-.4.3-.34.8.2 1.77 2.93 2.45M55.75 330.73c-3.09-2.49-5.95-3.72-9.89-2.12q-7.71 3.13-13.61 3.67c-3.09.28-6.62-1.76-10.28-1.28q-.48.06-.87-.25-1.9-1.54-4.29-1.99"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#171f24",
    vectorEffect: "non-scaling-stroke",
    d: "M40.37 298.45q6.67-3.03 8.91-11.29a2.12 1.98-17.7 0 1 .47-.84q1.41-1.54.75-3.29"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#121418",
    vectorEffect: "non-scaling-stroke",
    d: "m50.5 283.03.3-1.26a.53.52 19.4 0 1 .74-.35q1.5.74 2.54-.26a.51.5 55.5 0 1 .8.15l.53 1.1a.83.82 80 0 0 .65.46c2.33.25 6.82-.57 6.1-3.8q-.11-.49-.55-.75-2.2-1.29-4.75-1.15a.78.77 75 0 1-.74-.43q-.22-.45-.15-1.05"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#4d2a19",
    vectorEffect: "non-scaling-stroke",
    d: "M54.18 224.94c-.51 1.19-16.03-.56-18.14-.74q-.49-.04-.51.45-.15 3.37-.81 8.09c-.55 3.99 6.16 2.64 8.76 3.48"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#824b2d",
    vectorEffect: "non-scaling-stroke",
    d: "M38.53 253.51q-1.7.2-2.78-1.12a.68.67 54.3 0 0-.88-.15q-1.03.64-1.39 1.88-.13.47-.62.57l-.9.18a.75.75 0 0 1-.88-.86l2.58-16.48a2.17 2.17 0 0 0-1.97-2.5l-3.74-.3"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#793d33",
    vectorEffect: "non-scaling-stroke",
    d: "m81.15 276.01-1.32 15.16q-.04.53-.55.68-2.04.63-4.25.33"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#884f47",
    vectorEffect: "non-scaling-stroke",
    d: "M75.03 292.18q-4.94-1.96-4.56-5.09"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#793d33",
    vectorEffect: "non-scaling-stroke",
    d: "M70.47 287.09q.71-.97.34-1.65-4.64-8.54-14.21-10.08"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#351e12",
    vectorEffect: "non-scaling-stroke",
    d: "m236.66 221.41-16.04-.12"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#79675b",
    vectorEffect: "non-scaling-stroke",
    d: "M51.69 167.2q-1.14 1.43-4.01 2.57M33.49 175.27l-1.27.67"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#8f7a6e",
    vectorEffect: "non-scaling-stroke",
    d: "m32.22 175.94-1.82.27"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#607883",
    vectorEffect: "non-scaling-stroke",
    d: "m41.43 188.11-17.73-4.8"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#79675b",
    vectorEffect: "non-scaling-stroke",
    d: "M41.31 172.76q-1.05.99-3.2 1.01"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#8f7a6e",
    vectorEffect: "non-scaling-stroke",
    d: "M27.32 178.04q-.48 1.99-2.64 3.66"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#ad5748",
    vectorEffect: "non-scaling-stroke",
    d: "M68.52 308.52q.61 2.54-2.21 3.28"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#273138",
    vectorEffect: "non-scaling-stroke",
    d: "M50.5 283.03q-.31-.08-.27-.54"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#ad5748",
    vectorEffect: "non-scaling-stroke",
    d: "M66.71 306.11q-1.64.01-2.51 2.97"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#462e2d",
    vectorEffect: "non-scaling-stroke",
    d: "M62.94 301.5c-2.23-.35-3.6 2.21-1.86 3.96"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#9c5a4a",
    vectorEffect: "non-scaling-stroke",
    d: "M168.62 54.57c-4.67.87-7.2-1.03-11.78 2.29q-.48.35-.15.85l3.25 4.98a.79.79 0 0 0 1.36-.07l.96-1.82a.72.72 0 0 1 .99-.3c.79.43 1.41 1.14 2.21 1.23 2.83.33 3.85-4.83 3.78-6.66q-.02-.61-.62-.5M167.09 32.96q-7.08-1.94-11.37 3.57a.77.77 0 0 0 1.05 1.11q4.68-3.28 10.29-4.15 1.24-.2.03-.53"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#985b47",
    vectorEffect: "non-scaling-stroke",
    d: "m159.91 38.59 3.05.91a.71.7 17.6 0 0 .86-.44l.55-1.52a.71.71 0 0 0-.9-.91l-3.58 1.25q-1.1.39.02.71"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#f78a70",
    vectorEffect: "non-scaling-stroke",
    d: "M185.58 35.87q2.9-.37 3.12 2.28a.57.57 0 0 0 1.09.17q1.07-2.65-.21-5.1-.24-.46.04-.9 1.06-1.73-.13-3.52a2.08 2.07 53.8 0 0-3.03-.47q-3.31 2.68-1.7 7.04a.77.77 0 0 0 .82.5"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#222c33",
    vectorEffect: "non-scaling-stroke",
    d: "M218.19 171.17q-4.23 1.8-6.38-1.94-.27-.47-.77-.65c-6.15-2.28-8.61-.41-12.91 3.6a1.12 1.1 66.3 0 0-.35.92l.26 3.23q.04.43.46.53c4.51 1.08 10.31 3.11 12.33 1.52q3.19-2.52 7.14-3.33.46-.09.78-.43.96-1.01.76-2.68a.96.96 0 0 0-1.32-.77"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#0d0f13",
    vectorEffect: "non-scaling-stroke",
    d: "M94.69 221.44q-.65.18-.96.83a.46.46 0 0 0 .6.61l6.9-3.16a.36.35 35.5 0 0-.12-.68q-3.75-.39-6.42 2.4"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#171a1f",
    vectorEffect: "non-scaling-stroke",
    d: "M99.84 228.26c1.66-.06 11.72-.22 12.59-.88a.95.95 0 0 0-.4-1.7c-2.03-.36-12.54-.77-12.79 1.94q-.07.67.6.64"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#171f24",
    vectorEffect: "non-scaling-stroke",
    d: "m112.61 232.64 6.26 1.33a.74.74 0 0 0 .87-.57l.04-.16a3.7 3.56 12 0 0-2.88-4.25l-.47-.1a3.7 3.56 12 0 0-4.36 2.71l-.03.16a.74.74 0 0 0 .57.88"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#121418",
    vectorEffect: "non-scaling-stroke",
    d: "M55.752 292.81a2.68.83 14.7 0 0-2.381-1.483 2.68.83 14.7 0 0-2.803.123 2.68.83 14.7 0 0 2.381 1.483 2.68.83 14.7 0 0 2.803-.123"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#171f24",
    vectorEffect: "non-scaling-stroke",
    d: "M52.198 297.881a2.57.75 17 0 0-2.239-1.468 2.57.75 17 0 0-2.677-.034 2.57.75 17 0 0 2.239 1.468 2.57.75 17 0 0 2.677.034"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#121418",
    vectorEffect: "non-scaling-stroke",
    d: "M45.76 297.22a.1.09 21.4 0 0-.16.06q-.07.79.34 1.59.2.4.59.6l3.34 1.72a.31.31 0 0 0 .37-.06l.19-.19q.06-.05 0-.1l-4.67-3.62M40.13 301.2q-1.29 1.42-2.49 2.95a.34.34 0 0 0 .49.46q1.48-1.25 2.25-3.26.3-.76-.25-.15M46.07 304.43q-.7-1.56-1.69-2.91a.72.72 0 0 0-1.18.83l1.86 2.81q.15.22.39.1l.38-.18q.44-.21.24-.65M42.44 307.2q.24-.16.33-.55a.56.56 0 0 0-.59-.68l-2.54.19a.52.52 0 0 0-.42.77l1.75 3.1a.63.63 0 0 0 .99.14l.47-.47q.48-.49-.12-.82-.89-.5-.38-1.2.21-.28.51-.48"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#171f24",
    vectorEffect: "non-scaling-stroke",
    d: "M33.8 318.91q.62-.17.89-.76.21-.48-.21-.8c-2.52-1.87-4.8-3.84-8.08-3.85q-.52 0-.93.3-2.51 1.88-4.46 4.31-.37.47-.03.96c2.46 3.51 7.8 1.67 11.34.93q.14-.03.16-.17.07-.34.44-.55.42-.24.88-.37"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h256v337H0V0zm142.06 13.51.3 5.97q-1.68 4.63 1.76 8.05l2.33 10.01q-2.45 2.42 4.11 1.92a.7.57 31.8 0 1 .42 1.21q-.88.16-1.58-.23-.46-.26-.63.24-.16.5.26 1.07.81 7.42 5.3 14.41-.18.26-.35.52-9.99 1.24-19.78.75c-4.84-.24-8.07 4.85-11.04 7.7-1.74 1.67-4.34 2.78-6.25 4.81q-2.97 3.77-7.56 6.49l-49.69-.99a1.92 1.91-6.4 0 0-1.9 2.37l7.25 29.4c-21.56.36-43.61 2.07-64.01 9.18q-1.74 2.82.6 5.25.34.35.83.39l5.82.44 13.38 63.68c-.6 4.4-3 20.01.97 23.35l-3.1 2.69q-3.25 3.38-2.35 8.97.09.54.63.61l11.25 1.57q.43.05.37.48l-1.45 10.91-4.67 41.08a2.24 2.23-80.7 0 0 1.74 2.43q3.02.68 5.91-.45.52-.2.67-.73l6.93-23.55 4.95-17.29 9.56-1.2q-2.29 15.19-4.63 30.22c-.81 5.22 4 8.06 8.17 9.66q-.21.93.02.46-.28.65-.63.33-4.78 1.67-5.74 6.8-2.42-.24-3.42 2.07-4.08 9.48-6.44 13.89-5.05 5.73-11.6 9.82-.78.5-1.29 2.41-.13.51-.56.83c-4.71 3.51-9.13 6.8-8.33 12.44a.96.93 66.5 0 1-.32.85q-1.89 1.62-1.46 3.96c-.44 5.95 4.15 7.02 9.06 7.67 9.85 1.32 20.99-1.44 29.88-5.7l23.84-15.42c4.43-2.04 8.75-4.86 7.16-10.61L86 294.07l-1.17-7.43-1.31-3.8q1.7-.23 1.98-2.84 1.22-11.54 5.03-31.13l27.28-8.01 9.24-3.45q2.45-3.27-.16-8.71.06-.12.13-.24 13.19-.97 25.66 1.27l58.11 11.4 6.26 21.29q3.01 10.34 6.28 21.03c1.36 4.46 5.54 4.31 9.08 2.51a.65.64 73.7 0 0 .35-.65l-5.18-45.02-1.36-10.81q-.05-.47.42-.47l9.75-.17a1.15 1.14-83 0 0 1.09-.86q.99-3.89-.82-6.57l-5.39-9.74 16.64-80.65 1.32-6.29q2.32.88 4.49.4.48-.11.73-.52 2.09-3.38.59-5.74-9.53-5.41-20.01-6.96-2.32-6.54-2.57-13.5-.09-2.42-.75-4.57c-1.78-5.84 1.12-14.66-4.42-18.43q-7.11-4.85-16.6-9.08c-5.21-2.32-9.1-6.71-13.31-10.67l-4.59-3.8q-1.23-1.2-1.69-4.19l-1.27-5.48q4.32-6.16 2.12-13.34c.61-5.88 3.05-12.81-.33-18.01-7.07-10.85-17.8-12.15-29.54-9.24-3.64.9-9.82.93-12.53 3.19q-1.99 1.66-7.49 8.72z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#3a1917",
    d: "M191.95 28.85q-5.13-4.35-7.97-.21c-2.37 3.46-1.52 9.56-1.38 13.95q4.74 4.6 1.92 11.17-4.97 11.55-17.29 15.43-4.17.88-8.24-2.57l-1.89-2.86q-.37-.55-.75-.01-8.19 11.69-13.98 24.08l-4.54 8.94-.66-.01q-.58-.01-.39-.57 2.71-7.56 6.72-14.48c2.38-4.11 4.4-9.05 6.38-12.06 2.11-3.21 7.87-10.1 4.1-12.97q.17-.26.35-.52.77-.56 2.36-2.22 1.09-1.15 6.55-2.46 2.83.37 5.03-.61l5.41 2.52q.44.21.74-.17c4.09-5.21 4.12-12.85 3.1-19.41q-1.21-8.1-8.38-8.48l-4.19-3.45q-.36-.3-.84-.32l-3.82-.15-2.69-7.63q-.16-.44-.62-.5l-3.22-.44q2.71-1.27 4.91.18c1.51 1 1.57 2.87 3.27 4.09a1.63 1.62 13.4 0 0 2.56-1.57q-.3-1.83-1.4-3.67c-.58-.96-1.59-1.62-2.02-3.06q-.17-.58-.77-.69l-1.61-.28q-.72-.13-.57-.85l.6-2.79q.06-.26-.2-.25c-8.01.24-10.21 3.77-14.65 9.45q-.56.72-1.82.11 5.5-7.06 7.49-8.72c2.71-2.26 8.89-2.29 12.53-3.19 11.74-2.91 22.47-1.61 29.54 9.24 3.38 5.2.94 12.13.33 18.01zm-23.33 25.72c-4.67.87-7.2-1.03-11.78 2.29q-.48.35-.15.85l3.25 4.98a.79.79 0 0 0 1.36-.07l.96-1.82a.72.72 0 0 1 .99-.3c.79.43 1.41 1.14 2.21 1.23 2.83.33 3.85-4.83 3.78-6.66q-.02-.61-.62-.5z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#6a352e",
    d: "m153.76 12.84-4.36 4.89q-.62.7-.61-.23.03-2.36 1.02-4.48a.84.84 0 0 0-1.41-.88c-1.87 2.29-4.83 6.8-2.89 9.88q-.79-.17-1.27.3-.35-3.14-1.88-2.84l-.3-5.97q1.26.61 1.82-.11c4.44-5.68 6.64-9.21 14.65-9.45q.26-.01.2.25l-.6 2.79q-.15.72.57.85l1.61.28q.6.11.77.69c.43 1.44 1.44 2.1 2.02 3.06q1.1 1.84 1.4 3.67a1.63 1.62 13.4 0 1-2.56 1.57c-1.7-1.22-1.76-3.09-3.27-4.09q-2.2-1.45-4.91-.18z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#321a11",
    d: "m153.76 12.84 3.22.44q.46.06.62.5l2.69 7.63q-2.99-.81-4.27-2.01a1.15 1.15 0 0 0-1.82.35q-1.4 2.98-4.55 4.09-.4.14-.81.03l-.59-.15q-1.05-1.03-2.2-.99l-.54-.71c-1.94-3.08 1.02-7.59 2.89-9.88a.84.84 0 0 1 1.41.88q-.99 2.12-1.02 4.48-.01.93.61.23l4.36-4.89z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#fe9b7d",
    d: "m160.29 21.41 3.82.15q.48.02.84.32l4.19 3.45 6.06 8.26q.28.38.74.34l1.58-.12c1.02 6.56.99 14.2-3.1 19.41q-.3.38-.74.17l-5.41-2.52q-1.97-.68-5.03.61-5.46 1.31-6.55 2.46-1.59 1.66-2.36 2.22-4.49-6.99-5.3-14.41 1.44 1.56 2.79.71a1.16 1.16 0 0 0 .53-1.18q-.79-4.63-5.9-3.74l-2.33-10.01.12-5.21q.48-.47 1.27-.3l.54.71q-.1.38.03.68.19.45.68.42l1.49-.11.59.15q.41.11.81-.03 3.15-1.11 4.55-4.09a1.15 1.15 0 0 1 1.82-.35q1.28 1.2 4.27 2.01zm6.8 11.55q-7.08-1.94-11.37 3.57a.77.77 0 0 0 1.05 1.11q4.68-3.28 10.29-4.15 1.24-.2.03-.53zm-7.18 5.63 3.05.91a.71.7 17.6 0 0 .86-.44l.55-1.52a.71.71 0 0 0-.9-.91l-3.58 1.25q-1.1.39.02.71z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#020203",
    d: "M142.36 19.48q1.53-.3 1.88 2.84l-.12 5.21q-3.44-3.42-1.76-8.05z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#9c5c39",
    d: "M146.05 22.73q1.15-.04 2.2.99l-1.49.11q-.49.03-.68-.42-.13-.3-.03-.68z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#ef7862",
    d: "M169.14 25.33q7.17.38 8.38 8.48l-1.58.12q-.46.04-.74-.34l-6.06-8.26z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#fe9b7d",
    d: "M191.95 28.85q2.2 7.18-2.12 13.34-1.14-.15-1.99.64a1.13 1.11-62.2 0 1-.91.29l-4.33-.53c-.14-4.39-.99-10.49 1.38-13.95q2.84-4.14 7.97.21zm-6.37 7.02q2.9-.37 3.12 2.28a.57.57 0 0 0 1.09.17q1.07-2.65-.21-5.1-.24-.46.04-.9 1.06-1.73-.13-3.52a2.08 2.07 53.8 0 0-3.03-.47q-3.31 2.68-1.7 7.04a.77.77 0 0 0 .82.5z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#ef7862",
    d: "M184.76 35.37q-1.61-4.36 1.7-7.04a2.08 2.07 53.8 0 1 3.03.47q1.19 1.79.13 3.52-.28.44-.04.9 1.28 2.45.21 5.1a.57.57 0 0 1-1.09-.17q-.22-2.65-3.12-2.28a.77.77 0 0 1-.82-.5z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "#3a1917",
    d: "M167.06 33.49q-5.61.87-10.29 4.15a.77.77 0 0 1-1.05-1.11q4.29-5.51 11.37-3.57 1.21.33-.03.53z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "#321a11",
    d: "m162.96 39.5-3.05-.91q-1.12-.32-.02-.71l3.58-1.25a.71.71 0 0 1 .9.91l-.55 1.52a.71.7 17.6 0 1-.86.44z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "#020203",
    d: "M146.45 37.54q5.11-.89 5.9 3.74a1.16 1.16 0 0 1-.53 1.18q-1.35.85-2.79-.71-.42-.57-.26-1.07.17-.5.63-.24.7.39 1.58.23a.7.57 31.8 0 0-.42-1.21q-6.56.5-4.11-1.92z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "#ef7862",
    d: "m182.6 42.59 4.33.53a1.13 1.11-62.2 0 0 .91-.29q.85-.79 1.99-.64l1.27 5.48q-3.37 2.4-3.03 6.78a1.91 1.87 55.7 0 1-.17.95q-1.77 3.72-2.94 7.63c-.71 2.42-2.17 4.16-3.17 6.49-1.03 2.42-7.26 6.92-9.97 5.98-2.68-.93-1.56-4.21-3.06-4.79q.11-1.22-1.53-1.52 12.32-3.88 17.29-15.43 2.82-6.57-1.92-11.17z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fill: "#fe9b7d",
    d: "M191.1 47.67q.46 2.99 1.69 4.19c.54 3.76 2.74 8.06.45 11.59q-6.32 11.62-18.08 13.05c-3.92.48-8.34-.63-6.4-5.79 1.5.58.38 3.86 3.06 4.79 2.71.94 8.94-3.56 9.97-5.98 1-2.33 2.46-4.07 3.17-6.49q1.17-3.91 2.94-7.63a1.91 1.87 55.7 0 0 .17-.95q-.34-4.38 3.03-6.78z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fill: "#9c5c39",
    d: "M168.27 50.87q-2.2.98-5.03.61 3.06-1.29 5.03-.61z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fill: "#21262c",
    d: "m192.79 51.86 4.59 3.8q-2.5 11.08-3.77 14.65-.94 2.65-4.22 3.46l3.85-10.32c2.29-3.53.09-7.83-.45-11.59z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fill: "#fe9b7d",
    d: "M156.84 56.86c4.58-3.32 7.11-1.42 11.78-2.29q.6-.11.62.5c.07 1.83-.95 6.99-3.78 6.66-.8-.09-1.42-.8-2.21-1.23a.72.72 0 0 0-.99.3l-.96 1.82a.79.79 0 0 1-1.36.07l-3.25-4.98q-.33-.5.15-.85z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fill: "#2c3b44",
    d: "M197.38 55.66c4.21 3.96 8.1 8.35 13.31 10.67q9.49 4.23 16.6 9.08c5.54 3.77 2.64 12.59 4.42 18.43q.66 2.15.75 4.57.25 6.96 2.57 13.5l-1.57 5.71-1.1 3.61-.09 11.65c.45 12.1-.93 21.4-6.72 31.67l-.57.52q.84-2.59-.54-4.78a1.1 1.09 37.8 0 1-.12-.91q2.02-6.74-3.68-10.33a1.78 1.78 0 0 0-2.66 1.02l-2.34 8.22a.35.35 0 0 1-.55.18l-5.66-4.36a1.06 1.06 0 0 0-1.53 1.42q4.38 6.68 9.7 12.57.37.41.92.33l4.4-.62q-1.91 6.45-.55 12.37l.2 5.25c-7.36-3.79-20.25-5.53-27.67-5.4q-2.93-6.37 4.79-11.53c2.85-1.9 12.74-9.22 5.42-11.78-2.76-.96-6.65 2.15-8.54 3.99-5.15 5.03-9.24 9.32-16 9.16-4.65-.11-8.32-2.7-10.07-6.95a.54.53-3.9 0 1 .63-.72q.19.05.39.05.26-.01.39.21c4.08 6.91 12.86 6.79 17.96 1.43q.27-.27-.11-.33l-12.93-2.09a1 1 0 0 1-.49-1.75l2.28-1.97a.49.48-44.6 0 0 .01-.72q-.14-.13-.46-.12c3.52-2.08 2.64-12.09 1.63-15.27q.13-.06.25-.11c-.96-2.04-2.44-6.07-5.34-5.51a.39.39 0 0 1-.42-.56q.6-1.19 2.22-1.03c11.07 1.07 21.86 3.39 32.94 4.25a2.26 2.2-26.6 0 1 .98.31q2.62 1.55 5.58.8a.31.31 0 0 0-.03-.61q-1.79-.25-3.39-.97-2.52-1.13-.15-2.53c3.07-1.81 5.58-4.31 8.43-6.77q1.92-1.65.6-4.21a1.08 1.07 82.3 0 0-.7-.54c-5.02-1.15.56-9.4 1.97-11.52a1.02 1.02 0 0 0 .02-1.11q-3.17-5.14-8.57-2.27a1.26 1.26 0 0 1-1.84-1.25q.68-6.02 3.81-11.32a1.07 1.07 0 0 0 .08-.92l-.52-1.38a.18.17 48.4 0 0-.32-.02l-6.41 12.59q-.22.43-.69.54-.87.2-1.16.98-.16.41-.46.72l-2.23 2.23a1.64 1.55 15.2 0 1-.8.43q-2.22.47-4.08 1.7-.64.43-.82-.32l-.47-2.07a1.43 1.42-78.5 0 0-.54-.82q-1.45-1.08-3-2-.38-.22-.45-.66-.23-1.41.38-2.76 5.08-11.4 10.39-22.27a.44.44 0 0 0-.75-.45q-3.47 4.69-7.11 9.16c-.53.65-.51 1.48-.99 2.11-4.42 5.83-8.16 12.28-12.9 17.52q-4.58 5.06-9.23 10.07c-1.53 1.65-2.94 1.59-4.52.13l5.25-13.38 11.37-26.33 3.21-7.72q3.28-.81 4.22-3.46 1.27-3.57 3.77-14.65zm20.81 115.51q-4.23 1.8-6.38-1.94-.27-.47-.77-.65c-6.15-2.28-8.61-.41-12.91 3.6a1.12 1.1 66.3 0 0-.35.92l.26 3.23q.04.43.46.53c4.51 1.08 10.31 3.11 12.33 1.52q3.19-2.52 7.14-3.33.46-.09.78-.43.96-1.01.76-2.68a.96.96 0 0 0-1.32-.77zM153.98 56.68c3.77 2.87-1.99 9.76-4.1 12.97-1.98 3.01-4 7.95-6.38 12.06q-4.01 6.92-6.72 14.48-.19.56.39.57l.66.01q-6.04 12.67-10.24 25.89l-.64 2.83-.21.14q-.23.16-.29-.11l-6.79-33.24-.95-5.52 4.95-17.01a.92.92 0 0 0-1.61-.82q-2.12 2.74-5.14 1.01c1.91-2.03 4.51-3.14 6.25-4.81 2.97-2.85 6.2-7.94 11.04-7.7q9.79.49 19.78-.75z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fill: "#d6d9d9",
    d: "M158.99 66.62q-4.47 9.46-10.3 18.11-.29.44-.21.96c.24 1.65-1.14 2.36-1.6 3.3q-2.62 5.32-3.6 11.19-.29 1.69-1.37 3.78c-1.37 2.65-.88 5.8-2.89 7.87a1.43 1.35-21 0 0-.39.82q-.48 4.52-2.43 8.62a.97.95 6 0 1-.68.54l-3.08.63q-.38.07-.18-.26l4.04-6.56q.29-.46.32-1.01c.1-1.57 1.09-2.46 1.34-3.78q.8-4.37.76-8.76l3.65-14.24q5.79-12.39 13.98-24.08.38-.54.75.01l1.89 2.86z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m193.24 63.45-3.85 10.32-3.21 7.72-1.29-.06q-.45-.02-.71.36-3.65 5.4-7.67 10.56c-.63.81-.92 1.99-1.87 2.84-1.67 1.51-2.24 2.11-1.85 4.29q.11.59-.37.97l-1.72 1.35q-.41.32-.45.84-.18 2.15 1.2 3.73a1.41 1.41 0 0 0 .86.48q1.32.2 2.5.97l-5.25 13.38-4.4 16.23c-7.31-2.93-15.41-8.92-23.94-9.34-4.59-.23-9.24-.56-13.22.92-1.9.4-.93-2.49-1.05-3.52l.64-2.83 1.46-.2q.47-.06.47-.53-.01-1.99 1.73-2.94.46-.25.62-.74l.25-.73q.14-.4.53-.53c4.2-1.39 3.58-4.4 4.59-7.34q1.21-3.54 1.48-7.58.04 4.39-.76 8.76c-.25 1.32-1.24 2.21-1.34 3.78q-.03.55-.32 1.01l-4.04 6.56q-.2.33.18.26l3.08-.63a.97.95 6 0 0 .68-.54q1.95-4.1 2.43-8.62a1.43 1.35-21 0 1 .39-.82c2.01-2.07 1.52-5.22 2.89-7.87q1.08-2.09 1.37-3.78.98-5.87 3.6-11.19c.46-.94 1.84-1.65 1.6-3.3q-.08-.52.21-.96 5.83-8.65 10.3-18.11 4.07 3.45 8.24 2.57 1.64.3 1.53 1.52c-1.94 5.16 2.48 6.27 6.4 5.79q11.76-1.43 18.08-13.05z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fill: "#21262c",
    d: "m118.71 86.76-1.17-3.71q.45-2.91-1.2-5.6-.28-.47-.82-.51l-6.17-.51q4.59-2.72 7.56-6.49 3.02 1.73 5.14-1.01a.92.92 0 0 1 1.61.82l-4.95 17.01z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fill: "#d6d9d9",
    d: "m109.35 76.43 6.17.51q.54.04.82.51 1.65 2.69 1.2 5.6-9.23 5.85-16.41 14.31c-1.86 2.19-4.35 3.51-6.35 5.69q-2.19 2.36-2.67 2.82-1.47 1.38-2.85 2.61-12.25-4.61-22.32 3.21-.37.28-.89-.19-.1-.22-.27-.32l-.77-3.97-7.25-29.4a1.92 1.91-6.4 0 1 1.9-2.37l49.69.99zM186.18 81.49l-11.37 26.33q-1.18-.77-2.5-.97a1.41 1.41 0 0 1-.86-.48q-1.38-1.58-1.2-3.73.04-.52.45-.84l1.72-1.35q.48-.38.37-.97c-.39-2.18.18-2.78 1.85-4.29.95-.85 1.24-2.03 1.87-2.84q4.02-5.16 7.67-10.56.26-.38.71-.36l1.29.06z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fill: "#21262c",
    d: "m180.05 141.53-14.89-4.1 4.4-16.23c1.58 1.46 2.99 1.52 4.52-.13q4.65-5.01 9.23-10.07c4.74-5.24 8.48-11.69 12.9-17.52.48-.63.46-1.46.99-2.11q3.64-4.47 7.11-9.16a.44.44 0 0 1 .75.45q-5.31 10.87-10.39 22.27-.61 1.35-.38 2.76.07.44.45.66 1.55.92 3 2a1.43 1.42-78.5 0 1 .54.82l.47 2.07q.18.75.82.32 1.86-1.23 4.08-1.7a1.64 1.55 15.2 0 0 .8-.43l2.23-2.23q.3-.31.46-.72.29-.78 1.16-.98.47-.11.69-.54l6.41-12.59a.18.17 48.4 0 1 .32.02l.52 1.38a1.07 1.07 0 0 1-.08.92q-3.13 5.3-3.81 11.32a1.26 1.26 0 0 0 1.84 1.25q5.4-2.87 8.57 2.27a1.02 1.02 0 0 1-.02 1.11c-1.41 2.12-6.99 10.37-1.97 11.52a1.08 1.07 82.3 0 1 .7.54q1.32 2.56-.6 4.21c-2.85 2.46-5.36 4.96-8.43 6.77q-2.37 1.4.15 2.53 1.6.72 3.39.97a.31.31 0 0 1 .03.61q-2.96.75-5.58-.8a2.26 2.2-26.6 0 0-.98-.31c-11.08-.86-21.87-3.18-32.94-4.25q-1.62-.16-2.22 1.03a.39.39 0 0 0 .42.56c2.9-.56 4.38 3.47 5.34 5.51z"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fill: "#8298a2",
    d: "m117.54 83.05 1.17 3.71.95 5.52c-6.77-1.25-9.85 4.14-14.11 7.77q-2.97 2.53-5.04 4.7-4 4.19-7.69 5.94-2.06-2.16-3.56-2.21 1.38-1.23 2.85-2.61.48-.46 2.67-2.82c2-2.18 4.49-3.5 6.35-5.69q7.18-8.46 16.41-14.31zM142.37 87.83l-3.65 14.24q-.27 4.04-1.48 7.58c-1.01 2.94-.39 5.95-4.59 7.34q-.39.13-.53.53l-.25.73q-.16.49-.62.74-1.74.95-1.73 2.94 0 .47-.47.53l-1.46.2q4.2-13.22 10.24-25.89l4.54-8.94z"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    fill: "#76848d",
    d: "m119.66 92.28 6.79 33.24q.06.27.29.11l.21-.14c.12 1.03-.85 3.92 1.05 3.52q-.61 1 .16 1.55-.68.99-.72 1.67l-21.79-.07-5.7-9.39-7.13-12.08q3.69-1.75 7.69-5.94 2.07-2.17 5.04-4.7c4.26-3.63 7.34-9.02 14.11-7.77z"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    fill: "#2b323a",
    d: "M89.26 108.48q1.5.05 3.56 2.21l7.13 12.08-1.14 5.57c-1.94-2.69-5.78-8.6-9.05-9.15a.41.41 0 0 0-.38.66l8.38 10.43a.47.47 0 0 1-.48.76c-1.71-.43-3.65 2.75-4.53 4.01-2 2.86-.32 9.93.75 13.04.35 1.05 1.24 1.89 1.26 3.35q.01.51.37.87 7.21 7.29 12.3 16.18a.8.8 0 0 1-1.2 1.01q-5.33-4.32-10.85-8.36-8.43-6.16-1.28 1.44c1.89 2.01 13.23 9.25 13.11 11.62q-.02.62-.49.22-4.03-3.45-8.95-5.44a.81.8-65.2 0 0-1.02.38c-1.71 3.39-.71 6.04 2.4 8.21 3.5 2.43 8.65 5.34 10.42 9.37a.72.72 0 0 1-1.19.77c-1.81-1.97-7.89-7.8-10.93-6.53a.63.62 72.6 0 0-.37.71q.38 1.73 2 2.55.47.24.61.75.16.59.05 1.3-7.85-.47-12.01 5.52-3.04.97-4.98 5.58-1.09.73-1.88.65l-12.25-41.36q-.09-.31-.36-.48-.16-.1-.3-.24.5-.42.3-1.16c-3.18-11.99-6.7-22.91-6.2-34.49l1.55-6.15q1.79-.97 2.44-2.86.52.47.89.19 10.07-7.82 22.32-3.21z"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    fill: "#d78454",
    d: "m65.01 107.21.77 3.97c-12.27.71-28.27 1.64-41.6 4.55-2.23.48-6.83 3.17-8.43 2.97q-6.32-.78-12.68-.89-1.03-.02-2.07-1.42c20.4-7.11 42.45-8.82 64.01-9.18z"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    fill: "#9c5c39",
    d: "M65.78 111.18q.17.1.27.32-.65 1.89-2.44 2.86-4.16-.56-7.16.48-4.82-.76-9.79.59-4.07-.58-8.77 1.09-1.57-.54-3.94.23l-8.38 1.78q-.76-.25-1.32.96-4.24.24-5.93 2.67-.53-1.13-1.66.4l-8.41-.09-5.82-.44q-.49-.04-.83-.39-2.34-2.43-.6-5.25 1.04 1.4 2.07 1.42 6.36.11 12.68.89c1.6.2 6.2-2.49 8.43-2.97 13.33-2.91 29.33-3.84 41.6-4.55z"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    fill: "#d78454",
    d: "M235.03 111.91q10.48 1.55 20.01 6.96l-1.08.18q-.16.03-.19.18l-.04.29q-.04.21-.26.2l-14.7-.6q-2.76-1.69-5.31-1.5l1.57-5.71z"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    fill: "#673921",
    d: "m63.61 114.36-1.55 6.15c-4.09-1.42-1.24 6.72-1.41 8.63-.32 3.46.54 7.57.71 10.15q.64 9.91 1.84 19.77.04.37.42.42.22.03.45.15L63 161.17l-2.92 1.26-3.63-47.59q3-1.04 7.16-.48z"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m56.45 114.84 3.63 47.59-8.39 4.77-4.28-43.31-.75-8.46q4.97-1.35 9.79-.59z"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    fill: "#673921",
    d: "m46.66 115.43.75 8.46q-4.87-2.6-5.78 1.7a2.11 2.04-44.1 0 0-.02.64l6.07 43.54q-1.79 1.07-3.5.97l-6.29-54.22q4.7-1.67 8.77-1.09z"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m37.89 116.52 6.29 54.22q-.5 1.75-2.87 2.02l-6.42-49.24-.94-6.77q2.37-.77 3.94-.23z"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    fill: "#673921",
    d: "m33.95 116.75.94 6.77-4.69 1.61a1.62 1.62 0 0 0-1.06 1.83l8.97 46.81q-.92 1.04-3.05.7l-9.49-55.94 8.38-1.78z"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    fill: "#9c5c39",
    d: "M238.77 119.12q.76 1.55-.65 4.33-1.7-1.45-3.31-.97-.77-1.1-2.45-1.25l1.1-3.61q2.55-.19 5.31 1.5z"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m25.57 118.53 9.49 55.94q-2.05 2.84-1.57.8l-8.45-51.08-.79-4.7q.56-1.21 1.32-.96z"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    fill: "#b56a3f",
    d: "m238.77 119.12 14.7.6q.22.01.26-.2l.04-.29q.03-.15.19-.18l1.08-.18q1.5 2.36-.59 5.74-.25.41-.73.52-2.17.48-4.49-.4-5.99.61-11.11-1.28 1.41-2.78.65-4.33z"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    fill: "#404853",
    d: "M98.81 128.34c2.15 4.8 5.77 9.25 7.52 14.09 1.65 4.52 3.19 8.34 3.61 13.16.65 7.52.43 15.22 1.14 22.53q.73 7.47 1.06 15.13a.54.54 0 0 1-1.04.21l-.62-1.6q-.23-.6-.83-.37l-.92.35q-3.28-4.84-8.99-5.35.11-.71-.05-1.3-.14-.51-.61-.75-1.62-.82-2-2.55a.63.62 72.6 0 1 .37-.71c3.04-1.27 9.12 4.56 10.93 6.53a.72.72 0 0 0 1.19-.77c-1.77-4.03-6.92-6.94-10.42-9.37-3.11-2.17-4.11-4.82-2.4-8.21a.81.8-65.2 0 1 1.02-.38q4.92 1.99 8.95 5.44.47.4.49-.22c.12-2.37-11.22-9.61-13.11-11.62q-7.15-7.6 1.28-1.44 5.52 4.04 10.85 8.36a.8.8 0 0 0 1.2-1.01q-5.09-8.89-12.3-16.18-.36-.36-.37-.87c-.02-1.46-.91-2.3-1.26-3.35-1.07-3.11-2.75-10.18-.75-13.04.88-1.26 2.82-4.44 4.53-4.01a.47.47 0 0 0 .48-.76l-8.38-10.43a.41.41 0 0 1 .38-.66c3.27.55 7.11 6.46 9.05 9.15z"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    fill: "#673921",
    d: "m24.25 119.49.79 4.7q-2.57.27-3.77 2.5-.21.39-.06.8c1.3 3.52 1.66 7.58 2.49 10.94.82 3.34 1.01 7.23 1.52 10.08q2.51 13.89 5.18 27.7-1.3 1.65-1.89 1.07l-10.19-55.12q1.69-2.43 5.93-2.67z"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    fill: "#9c5c39",
    d: "M62.06 120.51c-.5 11.58 3.02 22.5 6.2 34.49q.2.74-.3 1.16l-3.89 3.47q-.23-.12-.45-.15-.38-.05-.42-.42-1.2-9.86-1.84-19.77c-.17-2.58-1.03-6.69-.71-10.15.17-1.91-2.68-10.05 1.41-8.63z"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M232.36 121.23q1.68.15 2.45 1.25l-1.12 4.73q-.13 3.18-1.42 5.67l.09-11.65zM18.32 122.16l10.19 55.12q-.3.53-1.19.76l-9.75-50.32-.91-5.16q1.13-1.53 1.66-.4z"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    fill: "#673921",
    d: "m16.66 122.56.91 5.16q-4.91.57-4.53 5.28.76 9.47 4.65 19.96a.86.85-36.3 0 1-.13.83c-1.24 1.58 5.48 23.25 5.46 27.57q0 .54.52.63.54.1 1.14-.29-.12.97-.98 1.61-.88 1.84-2.07 2.84L8.25 122.47l8.41.09zM238.12 123.45q5.12 1.89 11.11 1.28l-1.32 6.29q-1.88.15-4.46-1.42a1.32 1.31-56.9 0 0-1.77.38q-.78 1.13-1.05 2.49-3.45 17-7.4 33.89c-2.51 10.71-5.01 21.67-6.46 32.6q-.07.5-.43.86-.37.35-.82.46 0-.06-.01-.12l-.64-7.39c1.29-2.88 1.35-6.53 1.81-8.69q2.96-13.93 6.02-27.84 2.69-12.21 5.11-24.48.22-1.12.61-1.41a1.73 1.61-61.3 0 0-.78-3.07l-3.95-.07 1.12-4.73q1.61-.48 3.31.97z"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    fill: "#9c5c39",
    d: "m47.41 123.89 4.28 43.31q-1.14 1.43-4.01 2.57l-6.07-43.54a2.11 2.04-44.1 0 1 .02-.64q.91-4.3 5.78-1.7z"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    fill: "#181c22",
    d: "m99.95 122.77 5.7 9.39 8.98 13.66q.42.63-.31.84l-3.67 1.06q-.58.17-.41.75.36 1.21 1.31 2.09.38.35.55.85c1.63 4.85 4.09 9.37 3.57 14.84q-.05.52.34.87 1.46 1.34 2.67 2.9c3.5 4.5 1.3 14.19 8.99 15.24a.34.33 1.2 0 1 .28.29c.16 1.38 11.22 1.31 12.74 1.53 7.23 1.09 13.01-3.41 18.48-5.81 3.54-1.55 4.95-3.63 3.44-7.37a1.33 1.32 3.3 0 0-.62-.69c-3.87-2.09-5.49-1.43-8.27-5.32q-.28-.39-.71-.61c-2.5-1.27-4.96-.97-7.3-2q-4.28-1.86-8.55-3.89a1.59 1.59 0 0 1 .35-2.99l8.02-1.68a.98.97 65.2 0 0 .57-1.55c-1.74-2.26-4.28-1.94-6.14-2.87q-1.74-.88-3.36-1.97c-2.55-1.71-5.28-1.94-8.05-3.26a.95.94-78 0 1-.54-.84q0-.62-.7-.84a.79.79 0 0 1 .17-1.54l16.54-1.48q1.56.82 4.23-.21l5.68 3.65c4.42 1.83 8.6 2.62 12.65 4.96q5.7 3.3 11.59 6.14.32-.01.46.12a.49.48-44.6 0 1-.01.72l-2.28 1.97a1 1 0 0 0 .49 1.75l12.93 2.09q.38.06.11.33c-5.1 5.36-13.88 5.48-17.96-1.43q-.13-.22-.39-.21-.2 0-.39-.05a.54.53-3.9 0 0-.63.72c1.75 4.25 5.42 6.84 10.07 6.95 6.76.16 10.85-4.13 16-9.16 1.89-1.84 5.78-4.95 8.54-3.99 7.32 2.56-2.57 9.88-5.42 11.78q-7.72 5.16-4.79 11.53-10.72 3.78-27.9 7.45c-22.77 4.86-35.85 7.51-56.48 8.71l-1.79-4.35.92-.35q.6-.23.83.37l.62 1.6a.54.54 0 0 0 1.04-.21q-.33-7.66-1.06-15.13c-.71-7.31-.49-15.01-1.14-22.53-.42-4.82-1.96-8.64-3.61-13.16-1.75-4.84-5.37-9.29-7.52-14.09l1.14-5.57z"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    fill: "#9c5c39",
    d: "m34.89 123.52 6.42 49.24q-1.05.99-3.2 1.01l-8.97-46.81a1.62 1.62 0 0 1 1.06-1.83l4.69-1.61zM25.04 124.19l8.45 51.08-1.27.67-1.82.27q-2.67-13.81-5.18-27.7c-.51-2.85-.7-6.74-1.52-10.08-.83-3.36-1.19-7.42-2.49-10.94q-.15-.41.06-.8 1.2-2.23 3.77-2.5zM224.87 192.77l-2.15-6.36q-.19-.47-.15-.98l-.2-5.25q2.41-7.6 3.18-15.63c5.79-10.27 7.17-19.57 6.72-31.67q1.29-2.49 1.42-5.67l3.95.07a1.73 1.61-61.3 0 1 .78 3.07q-.39.29-.61 1.41-2.42 12.27-5.11 24.48-3.06 13.91-6.02 27.84c-.46 2.16-.52 5.81-1.81 8.69zM17.57 127.72l9.75 50.32q-.48 1.99-2.64 3.66-.6.39-1.14.29-.52-.09-.52-.63c.02-4.32-6.7-25.99-5.46-27.57a.86.85-36.3 0 0 .13-.83Q13.8 142.47 13.04 133q-.38-4.71 4.53-5.28z"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    fill: "#fe9b7d",
    d: "m165.16 137.43 14.89 4.1q-.12.05-.25.11-1 6.99-7.35 8.37-.28.06-.5.23l-.25.21q-.36.29-.74.04l-3.91-2.52q-.28-.18-.5-.43-1.21-1.44-3.8-2-5.43-1.17-8.82.27l-5.68-3.65q-3.96-3.41-8.85-5.06l-11.24-6.54q-.77-.55-.16-1.55c3.98-1.48 8.63-1.15 13.22-.92 8.53.42 16.63 6.41 23.94 9.34z"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    fill: "#b56a3f",
    d: "m247.91 131.02-16.64 80.65c-1.78 3.76-1.52 6.4-7.2 4.38q1.65-5.03 1.44-10.27l.01-5.5q.45-.11.82-.46.36-.36.43-.86c1.45-10.93 3.95-21.89 6.46-32.6q3.95-16.89 7.4-33.89.27-1.36 1.05-2.49a1.32 1.31-56.9 0 1 1.77-.38q2.58 1.57 4.46 1.42z"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    fill: "#d6d9d9",
    d: "m128.16 130.56 11.24 6.54c.47.43 2.75 1.96.8 2.2l-12.76-7.07q.04-.68.72-1.67z"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    fill: "#21262c",
    d: "m127.44 132.23 12.76 7.07 3.82 3.07-16.54 1.48a.79.79 0 0 0-.17 1.54q.7.22.7.84a.95.94-78 0 0 .54.84c2.77 1.32 5.5 1.55 8.05 3.26q1.62 1.09 3.36 1.97c1.86.93 4.4.61 6.14 2.87a.98.97 65.2 0 1-.57 1.55l-8.02 1.68a1.59 1.59 0 0 0-.35 2.99q4.27 2.03 8.55 3.89c2.34 1.03 4.8.73 7.3 2q.43.22.71.61c2.78 3.89 4.4 3.23 8.27 5.32a1.33 1.32 3.3 0 1 .62.69c1.51 3.74.1 5.82-3.44 7.37-5.47 2.4-11.25 6.9-18.48 5.81-1.52-.22-12.58-.15-12.74-1.53a.34.33 1.2 0 0-.28-.29c-7.69-1.05-5.49-10.74-8.99-15.24q-1.21-1.56-2.67-2.9-.39-.35-.34-.87c.52-5.47-1.94-9.99-3.57-14.84q-.17-.5-.55-.85-.95-.88-1.31-2.09-.17-.58.41-.75l3.67-1.06q.73-.21.31-.84l-8.98-13.66 21.79.07z"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    fill: "#404853",
    d: "M148.25 142.16q-2.67 1.03-4.23.21l-3.82-3.07c1.95-.24-.33-1.77-.8-2.2q4.89 1.65 8.85 5.06z"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    fill: "#ef7862",
    d: "M179.8 141.64c1.01 3.18 1.89 13.19-1.63 15.27q-5.89-2.84-11.59-6.14c-4.05-2.34-8.23-3.13-12.65-4.96q3.39-1.44 8.82-.27 2.59.56 3.8 2 .22.25.5.43l3.91 2.52q.38.25.74-.04l.25-.21q.22-.17.5-.23 6.35-1.38 7.35-8.37z"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    fill: "#21262c",
    d: "M224.98 165.07q-1.6 1.46-2.06 2.74l-4.4.62q-.55.08-.92-.33-5.32-5.89-9.7-12.57a1.06 1.06 0 0 1 1.53-1.42l5.66 4.36a.35.35 0 0 0 .55-.18l2.34-8.22a1.78 1.78 0 0 1 2.66-1.02q5.7 3.59 3.68 10.33a1.1 1.09 37.8 0 0 .12.91q1.38 2.19.54 4.78z"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    fill: "#181c22",
    d: "M67.96 156.16q.14.14.3.24.27.17.36.48l12.25 41.36q.71 4.72 5.22 5.26a1.1 1.09 47.2 0 1-.08 2.18l-1.89.08q-.47.02-.84-.28l-2.73-2.24q-.41-.34-.61-.84c-4.61-11.87-6.91-24.26-14.13-37.15-.82-1.46-2.02-2.02-3.11-3.31q.35-.22.3-.77l1.07-1.54 3.89-3.47z"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    fill: "#56727d",
    d: "M63 161.17q.05.55-.3.77-.93 1.07-1.01 1.56-2.36 13.97-3.51 28.35l-16.75-3.74q.4-.75.33-1.49-.05-.45-.48-.56c-2.04-.55-8.91-2.09-10.75-4.14q-.3-.33-.27-.78.16-3.05 2.43-4.8.45-.34-.11-.38l-.36-.02 1.27-.67q-.48 2.04 1.57-.8 2.13.34 3.05-.7 2.15-.02 3.2-1.01 2.37-.27 2.87-2.02 1.71.1 3.5-.97 2.87-1.14 4.01-2.57l8.39-4.77 2.92-1.26z"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    fill: "#21262c",
    d: "M62.7 161.94c1.09 1.29 2.29 1.85 3.11 3.31 7.22 12.89 9.52 25.28 14.13 37.15q.2.5.61.84l2.73 2.24q.37.3.84.28l1.89-.08a1.1 1.09 47.2 0 0 .08-2.18q-4.51-.54-5.22-5.26.79.08 1.88-.65c.6 6.05 6.11 1.77 7.25 6.57q.11.49.52.79.87.65.51 1.54-1.62-.68-2.21 1.02a.42.42 0 0 1-.54.26c-1.52-.52-3.58-1.3-2.75 1.57q1.4 4.88 3.09 9.52a.62.61-51.5 0 0 1.19-.14l.05-.44c2.15 9.97-9.4 15.89-4.57 25.6q-1.32.24-1.52 1.47-.09.52.24.93c.73.91.08 4.76-.21 7.02a1.39 1.35-18.3 0 1-.45.86c-2.09 1.87-3.49 3.2-3.68 6.23q-.33 5.16-.12 10.34a1.84 1.83-62.6 0 0 .29.92q1.2 1.81 1.5 3.91-.73-.07-.19.45-4.4-4.79-10.59-7.58c-3.9-1.75-10.49-1.93-12.45 2.6-.19.42-.7 4.41-1.53 3.87-4.17-1.6-8.98-4.44-8.17-9.66q2.34-15.03 4.63-30.22 1.71-4.09 1.14-10.08l.48-5.77q.04-.51-.45-.6-16.75-3.27-33.71-4.76-.72-.06-1-1.62l3.1-2.69c1.67 1.04 3.3 1.95 5.32 2.35q11.93 2.38 25.41 5.19 1.86.39 2.08-1.5l2.77-23.69q1.15-14.38 3.51-28.35.08-.49 1.01-1.56z"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M225.55 164.55q-.77 8.03-3.18 15.63-1.36-5.92.55-12.37.46-1.28 2.06-2.74l.57-.52z"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    fill: "#181c22",
    d: "M218.19 171.17a.96.96 0 0 1 1.32.77q.2 1.67-.76 2.68-.32.34-.78.43-3.95.81-7.14 3.33c-2.02 1.59-7.82-.44-12.33-1.52q-.42-.1-.46-.53l-.26-3.23a1.12 1.1 66.3 0 1 .35-.92c4.3-4.01 6.76-5.88 12.91-3.6q.5.18.77.65 2.15 3.74 6.38 1.94z"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    fill: "#8298a2",
    d: "m32.22 175.94.36.02q.56.04.11.38-2.27 1.75-2.43 4.8-.03.45.27.78c1.84 2.05 8.71 3.59 10.75 4.14q.43.11.48.56.07.74-.33 1.49l-17.73-4.8q.86-.64.98-1.61 2.16-1.67 2.64-3.66.89-.23 1.19-.76.59.58 1.89-1.07l1.82-.27z"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    fill: "#56727d",
    d: "M222.57 185.43q-.04.51.15.98l-3.51 6.47q-.25.45-.71.67-4.59 2.22-9.71 2.59a.75.75 0 0 0-.41 1.34c1.52 1.19 9.51.64 11.5.27q.48-.1.84.25 2.07 1.99 4.79 2.16.01.06.01.12l-.01 5.5q-1.21-1.33-1.35-3.29-.05-.6-.64-.56-1.59.1-2.08-1.21-.19-.51-.73-.6c-3.73-.6-7.41.77-10.82 1.18-3.03.37-5.32 1.86-8.14 2.45q-7.53 1.58-13.29 6.16a1.81 1.81 0 0 1-.86.37q-4.92.72-8.83 3.63a1.73 1.68 25 0 1-.95.33q-1.69.05-2.6 1.42-.3.44-.74.73l-2.62 1.71q-.4.26-.43.73-.16 2.11-3.49 2.93-20.78 1.31-42.39.43-1.42-5.08-5.14-9.13l-2.72-1.81-2.47-1.67q.68-.59.47-1.02-2.99-5.92-5.17-12.37c20.63-1.2 33.71-3.85 56.48-8.71q17.18-3.67 27.9-7.45c7.42-.13 20.31 1.61 27.67 5.4z"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    fill: "#3d5863",
    d: "m23.7 183.31 17.73 4.8 16.75 3.74-2.77 23.69q-.22 1.89-2.08 1.5-13.48-2.81-25.41-5.19c-2.02-.4-3.65-1.31-5.32-2.35-3.97-3.34-1.57-18.95-.97-23.35q1.19-1 2.07-2.84z"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    fill: "#fe9b7d",
    d: "M99.74 186.49q5.71.51 8.99 5.35l1.79 4.35q2.18 6.45 5.17 12.37.21.43-.47 1.02l-.7-.27q-5.07-4.46-11.67-4.02-.5.03-.9-.28c-2.76-2.15-6.01.33-8.48 1.83q-.45.28-.69-.2c-1.96-3.92-5.81-10.36-5.05-14.63q4.16-5.99 12.01-5.52z"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    fill: "#8298a2",
    d: "m222.72 186.41 2.15 6.36.64 7.39q-2.72-.17-4.79-2.16-.36-.35-.84-.25c-1.99.37-9.98.92-11.5-.27a.75.75 0 0 1 .41-1.34q5.12-.37 9.71-2.59.46-.22.71-.67l3.51-6.47z"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    fill: "#020203",
    d: "M87.73 192.01c-.76 4.27 3.09 10.71 5.05 14.63q.24.48.69.2c2.47-1.5 5.72-3.98 8.48-1.83q.4.31.9.28 6.6-.44 11.67 4.02.09.51-.11.85-.29.49-.79.21l-2.86-1.56q-1.86-2.1-3.74-1.76-.57.1-.72.66l-2.08 7.83q-.69.67-.7 1.34-.01.52.5.65 6.19 1.59 9.89 6.77a1.18 1.18 0 0 0 1.98-1.29q-1.1-1.87-.37-3.3l3.39 5.04q.29.44.66.06c.46-.49-2.34-6.45-2.67-7.16q1.88 1.06 3.51-4.59 3.72 4.05 5.14 9.13l1.47 6.27q-.07.12-.13.24l-2.25.43q-.53.1-.56.63-.32 5.18 2.97 7.65l-9.24 3.45q-4.65-5.11-12.56-4.36c-4.46.42-16.41 3.6-16.92 9.54q-.04.44.38.59 1.01.36.36 1.95-2.26-1.13-3.78-4.7c-4.83-9.71 6.72-15.63 4.57-25.6q-1.69-5.62 1.87-10.26.29-.38.06-.81-.25-.46-.76-.72.36-.89-.51-1.54-.41-.3-.52-.79c-1.14-4.8-6.65-.52-7.25-6.57q1.94-4.61 4.98-5.58zm6.96 29.43q-.65.18-.96.83a.46.46 0 0 0 .6.61l6.9-3.16a.36.35 35.5 0 0-.12-.68q-3.75-.39-6.42 2.4zm5.15 6.82c1.66-.06 11.72-.22 12.59-.88a.95.95 0 0 0-.4-1.7c-2.03-.36-12.54-.77-12.79 1.94q-.07.67.6.64zm12.77 4.38 6.26 1.33a.74.74 0 0 0 .87-.57l.04-.16a3.7 3.56 12 0 0-2.88-4.25l-.47-.1a3.7 3.56 12 0 0-4.36 2.71l-.03.16a.74.74 0 0 0 .57.88z"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    fill: "#3d5863",
    d: "M225.51 205.78q.21 5.24-1.44 10.27-.61 2.33-3.45 5.24l-52.68.47q3.33-.82 3.49-2.93.03-.47.43-.73l2.62-1.71q.44-.29.74-.73.91-1.37 2.6-1.42a1.73 1.68 25 0 0 .95-.33q3.91-2.91 8.83-3.63a1.81 1.81 0 0 0 .86-.37q5.76-4.58 13.29-6.16c2.82-.59 5.11-2.08 8.14-2.45 3.41-.41 7.09-1.78 10.82-1.18q.54.09.73.6.49 1.31 2.08 1.21.59-.04.64.56.14 1.96 1.35 3.29z"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    fill: "#2b323a",
    d: "M91.03 206.49q.51.26.76.72.23.43-.06.81-3.56 4.64-1.87 10.26l-.05.44a.62.61-51.5 0 1-1.19.14q-1.69-4.64-3.09-9.52c-.83-2.87 1.23-2.09 2.75-1.57a.42.42 0 0 0 .54-.26q.59-1.7 2.21-1.02zM110.76 208.81l-1.4 6.31a1.53 1.52-64.2 0 1-2.45.86q-.9-.73-2.69-.44l2.08-7.83q.15-.56.72-.66 1.88-.34 3.74 1.76z"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    fill: "#21262c",
    d: "m110.76 208.81 2.86 1.56q.5.28.79-.21.2-.34.11-.85l.7.27 2.47 1.67q-2.97 1.14-3.84 3.95-.44.51-.57 1.01-.12.5.25.85 1.58 1.5 1.99 2.65-.73 1.43.37 3.3a1.18 1.18 0 0 1-1.98 1.29q-3.7-5.18-9.89-6.77-.51-.13-.5-.65.01-.67.7-1.34 1.79-.29 2.69.44a1.53 1.52-64.2 0 0 2.45-.86l1.4-6.31z"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    fill: "#2b323a",
    d: "m117.69 211.25 2.72 1.81q-1.63 5.65-3.51 4.59l-3.05-2.45q.87-2.81 3.84-3.95z"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    fill: "#020203",
    d: "m231.27 211.67 5.39 9.74-16.04-.12q2.84-2.91 3.45-5.24c5.68 2.02 5.42-.62 7.2-4.38z"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    fill: "#673921",
    d: "M19.5 212.19q.28 1.56 1 1.62 16.96 1.49 33.71 4.76.49.09.45.6l-.48 5.77c-.51 1.19-16.03-.56-18.14-.74q-.49-.04-.51.45-.15 3.37-.81 8.09c-.55 3.99 6.16 2.64 8.76 3.48l-4.95 17.29q-1.7.2-2.78-1.12a.68.67 54.3 0 0-.88-.15q-1.03.64-1.39 1.88-.13.47-.62.57l-.9.18a.75.75 0 0 1-.88-.86l2.58-16.48a2.17 2.17 0 0 0-1.97-2.5l-3.74-.3 1.45-10.91q.06-.43-.37-.48l-11.25-1.57q-.54-.07-.63-.61-.9-5.59 2.35-8.97z"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    fill: "#ef7862",
    d: "m113.85 215.2 3.05 2.45c.33.71 3.13 6.67 2.67 7.16q-.37.38-.66-.06l-3.39-5.04q-.41-1.15-1.99-2.65-.37-.35-.25-.85.13-.5.57-1.01z"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    fill: "#181c22",
    d: "M94.69 221.44q2.67-2.79 6.42-2.4a.36.35 35.5 0 1 .12.68l-6.9 3.16a.46.46 0 0 1-.6-.61q.31-.65.96-.83z"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    fill: "#673921",
    d: "m220.62 221.29 16.04.12q1.81 2.68.82 6.57a1.15 1.14-83 0 1-1.09.86l-9.75.17q-.47 0-.42.47l1.36 10.81c-3.8-.53-5.35 1.07-4.94 4.87.64 5.92.55 14.45-5.59 17.26l-6.26-21.29q4.18.53 7.74-.46.5-.14.44-.65c-.37-3.05-1.89-7.37-1.37-10.28q.09-.49-.41-.54-1.98-.2-3.94-.26-28.38-.79-56.76-.14c-1.18.03-3.76-1.2-3.81.93q-12.47-2.24-25.66-1.27l-1.47-6.27q21.61.88 42.39-.43l52.68-.47z"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    fill: "#321a11",
    d: "M54.18 224.94q.57 5.99-1.14 10.08l-9.56 1.2c-2.6-.84-9.31.51-8.76-3.48q.66-4.72.81-8.09.02-.49.51-.45c2.11.18 17.63 1.93 18.14.74z"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    fill: "#2b323a",
    d: "M112.43 227.38c-.87.66-10.93.82-12.59.88q-.67.03-.6-.64c.25-2.71 10.76-2.3 12.79-1.94a.95.95 0 0 1 .4 1.7z"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    fill: "#321a11",
    d: "m210.79 241.13-58.11-11.4c.05-2.13 2.63-.9 3.81-.93q28.38-.65 56.76.14 1.96.06 3.94.26.5.05.41.54c-.52 2.91 1 7.23 1.37 10.28q.06.51-.44.65-3.56.99-7.74.46z"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    fill: "#2c3b44",
    d: "M112.61 232.64a.74.74 0 0 1-.57-.88l.03-.16a3.7 3.56 12 0 1 4.36-2.71l.47.1a3.7 3.56 12 0 1 2.88 4.25l-.04.16a.74.74 0 0 1-.87.57l-6.26-1.33z"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    fill: "#2b323a",
    d: "M126.89 228.7q2.61 5.44.16 8.71-3.29-2.47-2.97-7.65.03-.53.56-.63l2.25-.43z"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    fill: "#9c5c39",
    d: "m27.95 234.73 3.74.3a2.17 2.17 0 0 1 1.97 2.5l-2.58 16.48a.75.75 0 0 0 .88.86l.9-.18q.49-.1.62-.57.36-1.24 1.39-1.88a.68.67 54.3 0 1 .88.15q1.08 1.32 2.78 1.12l-6.93 23.55q-.15.53-.67.73-2.89 1.13-5.91.45a2.24 2.23-80.7 0 1-1.74-2.43l4.67-41.08z"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    fill: "#21262c",
    d: "m117.81 240.86-27.28 8.01q-.39.33-1.46-.29.65-1.59-.36-1.95-.42-.15-.38-.59c.51-5.94 12.46-9.12 16.92-9.54q7.91-.75 12.56 4.36z"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    fill: "#9c5c39",
    d: "m227.58 240.29 5.18 45.02a.65.64 73.7 0 1-.35.65c-3.54 1.8-7.72 1.95-9.08-2.51q-3.27-10.69-6.28-21.03c6.14-2.81 6.23-11.34 5.59-17.26-.41-3.8 1.14-5.4 4.94-4.87z"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    fill: "#2b323a",
    d: "M85.29 243.88q1.52 3.57 3.78 4.7 1.07.62 1.46.29-3.81 19.59-5.03 31.13-.28 2.61-1.98 2.84.23-3.63-2.18-7.28-.3-2.1-1.5-3.91a1.84 1.83-62.6 0 1-.29-.92q-.21-5.18.12-10.34c.19-3.03 1.59-4.36 3.68-6.23a1.39 1.35-18.3 0 0 .45-.86c.29-2.26.94-6.11.21-7.02q-.33-.41-.24-.93.2-1.23 1.52-1.47z"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    fill: "#ef7862",
    d: "m81.15 276.01-1.32 15.16q-.04.53-.55.68-2.04.63-4.25.33-4.94-1.96-4.56-5.09.71-.97.34-1.65-4.64-8.54-14.21-10.08-.23.47-.02-.46c.83.54 1.34-3.45 1.53-3.87 1.96-4.53 8.55-4.35 12.45-2.6q6.19 2.79 10.59 7.58z"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    fill: "#020203",
    d: "M56.6 275.36q9.57 1.54 14.21 10.08.37.68-.34 1.65c-4.5-2.06-5.35.41-7.71 3.08q-8.71 9.82-17.77 19.32-1.58 1.65-2.66 5.08c-.76 2.4.47 5.45-3.72 6.08a1.84 1.83 22 0 0-.83.35c-3.34 2.59-6.2 2.95-8.76 7.04q-.24.4-.66.59l-.73.34q-.8.37.08.49 11.16 1.45 19.77-3.44 1.43-.81 2.48-1.17c6.01-2.04 11.91-6.94 13.76-11.95a.76.76 0 0 0-.39-.95q-4.88-2.31-8.19 2.22-3.14 4.3-10.25 6.33-.42.12-.56-.3-.52-1.65 1.18-2.24c2.63-.91 3.53-3.04 5.75-4.34q.47-.28.28-.79l-.52-1.39a.78.78 0 0 1 .99-1c5.2 1.87 2.59-3.97 6.39-3.43a.54.54 0 0 0 .59-.4q.37-1.29 2.09-1.15l3.12 3.62 2.11 2.72 2.65 5.06q.27.51.71.14c2.83-2.37.6-6.07-1.15-8.48q-.52-1.36-1.81-2.41l-3.77-4.61q1.03-1.36 3.43-.94c5.81 1.01 5.98 10.81 13.83 6.4q3.38-1.9 2.61-5.74-.1-.5-.61-.52c-4.61-.13-11.95-1.46-14.22-5.84q-.2-.4.03-.78l1.5-2.43a.81.81 0 0 1 1.49.53l-.3 2.22a.98.97-70.6 0 0 .46.97q3.14 1.87 6.76 1.25a1.2 1.2 0 0 0-.12-2.38q-2.93-.2-2.77-2.06 2.21.3 4.25-.33.51-.15.55-.68l1.32-15.16q-.54-.52.19-.45 2.41 3.65 2.18 7.28l1.31 3.8q-1.56 1.76-2.05 3.67a.84.84 0 0 0 .23.81l2.99 2.95.75 10.63-9.75 7.36q-.4.3-.34.8.2 1.77 2.93 2.45l-23.84 15.42c-3.09-2.49-5.95-3.72-9.89-2.12q-7.71 3.13-13.61 3.67c-3.09.28-6.62-1.76-10.28-1.28q-.48.06-.87-.25-1.9-1.54-4.29-1.99-.43-2.34 1.46-3.96a.96.93 66.5 0 0 .32-.85c-.8-5.64 3.62-8.93 8.33-12.44q.43-.32.56-.83.51-1.91 1.29-2.41 6.55-4.09 11.6-9.82 6.67-3.03 8.91-11.29a2.12 1.98-17.7 0 1 .47-.84q1.41-1.54.75-3.29l.3-1.26a.53.52 19.4 0 1 .74-.35q1.5.74 2.54-.26a.51.5 55.5 0 1 .8.15l.53 1.1a.83.82 80 0 0 .65.46c2.33.25 6.82-.57 6.1-3.8q-.11-.49-.55-.75-2.2-1.29-4.75-1.15a.78.77 75 0 1-.74-.43q-.22-.45-.15-1.05.35.32.63-.33zm-.848 17.45a2.68.83 14.7 0 0-2.381-1.483 2.68.83 14.7 0 0-2.803.123 2.68.83 14.7 0 0 2.381 1.483 2.68.83 14.7 0 0 2.803-.123zm-3.554 5.071a2.57.75 17 0 0-2.239-1.468 2.57.75 17 0 0-2.677-.034 2.57.75 17 0 0 2.239 1.468 2.57.75 17 0 0 2.677.034zm-6.438-.661a.1.09 21.4 0 0-.16.06q-.07.79.34 1.59.2.4.59.6l3.34 1.72a.31.31 0 0 0 .37-.06l.19-.19q.06-.05 0-.1l-4.67-3.62zm-5.63 3.98q-1.29 1.42-2.49 2.95a.34.34 0 0 0 .49.46q1.48-1.25 2.25-3.26.3-.76-.25-.15zm5.94 3.23q-.7-1.56-1.69-2.91a.72.72 0 0 0-1.18.83l1.86 2.81q.15.22.39.1l.38-.18q.44-.21.24-.65zm-3.63 2.77q.24-.16.33-.55a.56.56 0 0 0-.59-.68l-2.54.19a.52.52 0 0 0-.42.77l1.75 3.1a.63.63 0 0 0 .99.14l.47-.47q.48-.49-.12-.82-.89-.5-.38-1.2.21-.28.51-.48zm-8.64 11.71q.62-.17.89-.76.21-.48-.21-.8c-2.52-1.87-4.8-3.84-8.08-3.85q-.52 0-.93.3-2.51 1.88-4.46 4.31-.37.47-.03.96c2.46 3.51 7.8 1.67 11.34.93q.14-.03.16-.17.07-.34.44-.55.42-.24.88-.37z"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    fill: "#21262c",
    d: "M55.97 275.69q-.07.6.15 1.05a.78.77 75 0 0 .74.43q2.55-.14 4.75 1.15.44.26.55.75c.72 3.23-3.77 4.05-6.1 3.8a.83.82 80 0 1-.65-.46l-.53-1.1a.51.5 55.5 0 0-.8-.15q-1.04 1-2.54.26a.53.52 19.4 0 0-.74.35l-.3 1.26q-.31-.08-.27-.54.96-5.13 5.74-6.8z"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    fill: "#2c3b44",
    d: "M50.23 282.49q-.04.46.27.54.66 1.75-.75 3.29a2.12 1.98-17.7 0 0-.47.84q-2.24 8.26-8.91 11.29 2.36-4.41 6.44-13.89 1-2.31 3.42-2.07z"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    fill: "#21262c",
    d: "M70.47 287.09q-.38 3.13 4.56 5.09-.16 1.86 2.77 2.06a1.2 1.2 0 0 1 .12 2.38q-3.62.62-6.76-1.25a.98.97-70.6 0 1-.46-.97l.3-2.22a.81.81 0 0 0-1.49-.53l-1.5 2.43q-.23.38-.03.78c2.27 4.38 9.61 5.71 14.22 5.84q.51.02.61.52.77 3.84-2.61 5.74c-7.85 4.41-8.02-5.39-13.83-6.4q-2.4-.42-3.43.94c-2.23-.35-3.6 2.21-1.86 3.96q-1.72-.14-2.09 1.15a.54.54 0 0 1-.59.4c-3.8-.54-1.19 5.3-6.39 3.43a.78.78 0 0 0-.99 1l.52 1.39q.19.51-.28.79c-2.22 1.3-3.12 3.43-5.75 4.34q-1.7.59-1.18 2.24.14.42.56.3 7.11-2.03 10.25-6.33 3.31-4.53 8.19-2.22a.76.76 0 0 1 .39.95c-1.85 5.01-7.75 9.91-13.76 11.95q-1.05.36-2.48 1.17-8.61 4.89-19.77 3.44-.88-.12-.08-.49l.73-.34q.42-.19.66-.59c2.56-4.09 5.42-4.45 8.76-7.04a1.84 1.83 22 0 1 .83-.35c4.19-.63 2.96-3.68 3.72-6.08q1.08-3.43 2.66-5.08 9.06-9.5 17.77-19.32c2.36-2.67 3.21-5.14 7.71-3.08z"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    fill: "#9c5c39",
    d: "m84.83 286.64 1.17 7.43-2.99-2.95a.84.84 0 0 1-.23-.81q.49-1.91 2.05-3.67z"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    fill: "#21262c",
    transform: "rotate(14.7 -1105.794 352.127)",
    rx: 2.68,
    ry: 0.83
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    fill: "#2c3b44",
    transform: "rotate(17 -969.202 314.974)",
    rx: 2.57,
    ry: 0.75
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    fill: "#21262c",
    d: "m45.76 297.22 4.67 3.62q.06.05 0 .1l-.19.19a.31.31 0 0 1-.37.06l-3.34-1.72q-.39-.2-.59-.6-.41-.8-.34-1.59a.1.09 21.4 0 1 .16-.06zM40.38 301.35q-.77 2.01-2.25 3.26a.34.34 0 0 1-.49-.46q1.2-1.53 2.49-2.95.55-.61.25.15zM46.07 304.43q.2.44-.24.65l-.38.18q-.24.12-.39-.1l-1.86-2.81a.72.72 0 0 1 1.18-.83q.99 1.35 1.69 2.91z"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    fill: "#6a352e",
    d: "m62.94 301.5 3.77 4.61q-1.64.01-2.51 2.97l-3.12-3.62c-1.74-1.75-.37-4.31 1.86-3.96z"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    fill: "#2b323a",
    d: "M86.75 304.7c1.59 5.75-2.73 8.57-7.16 10.61q-2.73-.68-2.93-2.45-.06-.5.34-.8l9.75-7.36z"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    fill: "#21262c",
    d: "M41.93 307.68q-.51.7.38 1.2.6.33.12.82l-.47.47a.63.63 0 0 1-.99-.14l-1.75-3.1a.52.52 0 0 1 .42-.77l2.54-.19a.56.56 0 0 1 .59.68q-.09.39-.33.55-.3.2-.51.48z"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    fill: "#ef7862",
    d: "M66.71 306.11q1.29 1.05 1.81 2.41.61 2.54-2.21 3.28l-2.11-2.72q.87-2.96 2.51-2.97z"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    fill: "#6a352e",
    d: "M68.52 308.52c1.75 2.41 3.98 6.11 1.15 8.48q-.44.37-.71-.14l-2.65-5.06q2.82-.74 2.21-3.28z"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    fill: "#2c3b44",
    d: "M32.92 319.28q-.37.21-.44.55-.02.14-.16.17c-3.54.74-8.88 2.58-11.34-.93q-.34-.49.03-.96 1.95-2.43 4.46-4.31.41-.3.93-.3c3.28.01 5.56 1.98 8.08 3.85q.42.32.21.8-.27.59-.89.76-.46.13-.88.37z"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    fill: "#2b323a",
    d: "M55.75 330.73c-8.89 4.26-20.03 7.02-29.88 5.7-4.91-.65-9.5-1.72-9.06-7.67q2.39.45 4.29 1.99.39.31.87.25c3.66-.48 7.19 1.56 10.28 1.28q5.9-.54 13.61-3.67c3.94-1.6 6.8-.37 9.89 2.12z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOwner);
export default __webpack_public_path__ + "static/media/owner.d72062aa0c566834ae84543a5ccf16c6.svg";
export { ForwardRef as ReactComponent };